window.SPF_DATA = {
  'APRILIA': [

    {
      s:'aprilia-dorsoduro-750-smv',
      l:'APRILIA DORSODURO 750 SMV',
      y:[2007,2008,2009,2010,2011,2012,2013,2014,2015],

      g:[
        {id:'aprilia-dorsoduro-750-smv-gen1',years:[2007,2008,2009,2010,2011,2012,2013,2014,2015]}
      ]
    },

    {
      s:'aprilia-tuono-1000',
      l:'APRILIA TUONO 1000',
      y:[2002,2003,2004,2005,2006],

      g:[
        {id:'aprilia-tuono-1000-gen1',years:[2002,2003,2004,2005,2006]}
      ]
    },

    {
      s:'aprilia-tuono-1000r',
      l:'APRILIA TUONO 1000R',
      y:[2004,2007,2008,2009,2010],

      g:[
        {id:'aprilia-tuono-1000r-gen1',years:[2004]},
        {id:'aprilia-tuono-1000r-gen2',years:[2007,2008,2009,2010]}
      ]
    },

    {
      s:'aprilia-tuono-1000r-factory',
      l:'APRILIA TUONO 1000R FACTORY',
      y:[2006,2007,2008,2009],

      g:[
        {id:'aprilia-tuono-1000r-factory-gen1',years:[2006,2007,2008,2009]}
      ]
    },

    {
      s:'aprilia-tuono-v4r',
      l:'APRILIA TUONO V4R',
      y:[2011,2012],

      g:[
        {id:'aprilia-tuono-v4r-gen1',years:[2011,2012]}
      ]
    },

    {
      s:'aprilia-tuono-v4r-aprc',
      l:'APRILIA TUONO V4R APRC',
      y:[2012,2013,2014,2015],

      g:[
        {id:'aprilia-tuono-v4r-aprc-gen1',years:[2012,2013,2014,2015]}
      ]
    },

    {
      s:'aprilia-tuono-v4-1100-factory',
      l:'APRILIA TUONO V4 1100 FACTORY',
      y:[2015,2016,2017,2018,2019,2020],

      g:[
        {id:'aprilia-tuono-v4-1100-factory-gen1',years:[2015,2016,2017,2018,2019,2020]}
      ]
    },

    {
      s:'aprilia-tuono-v4-1100rr',
      l:'APRILIA TUONO V4 1100RR',
      y:[2015,2016,2017,2018,2019,2020],

      g:[
        {id:'aprilia-tuono-v4-1100rr-gen1',years:[2015,2016,2017,2018,2019,2020]}
      ]
    },

    {
      s:'aprilia-rs660',
      l:'APRILIA RS660',
      y:[2020,2021,2022,2023,2024],

      g:[
        {id:'aprilia-rs660-gen1',years:[2020,2021,2022,2023,2024]}
      ]
    },

    {
      s:'aprilia-rs660-kyb-fork',
      l:'APRILIA RS660 (KYB FORK)',
      y:[2025,2026],

      g:[
        {id:'aprilia-rs660-kyb-fork-gen1',years:[2025,2026]}
      ]
    },

    {
      s:'aprilia-rs660-wuxi-fork',
      l:'APRILIA RS660 (WUXI FORK)',
      y:[2025,2026],

      g:[
        {id:'aprilia-rs660-wuxi-fork-gen1',years:[2025,2026]}
      ]
    },

    {
      s:'aprilia-rs660-factory',
      l:'APRILIA RS660 FACTORY',
      y:[2025,2026],

      g:[
        {id:'aprilia-rs660-factory-gen1',years:[2025,2026]}
      ]
    },

    {
      s:'aprilia-rs-457',
      l:'APRILIA RS 457',
      y:[2024,2025,2026],

      g:[
        {id:'aprilia-rs-457-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'aprilia-tuono-660-factory',
      l:'APRILIA TUONO 660 FACTORY',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'aprilia-tuono-660-factory-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'aprilia-tuareg-660',
      l:'APRILIA TUAREG 660',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'aprilia-tuareg-660-gen1',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'aprilia-rsv4-1100',
      l:'APRILIA RSV4 1100',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'aprilia-rsv4-1100-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'aprilia-rsv4-1100-factory',
      l:'APRILIA RSV4 1100 FACTORY',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'aprilia-rsv4-1100-factory-gen1',years:[2019,2020]},
        {id:'aprilia-rsv4-1100-factory-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },
  ],

  'BETA': [

    {
      s:'beta-rr-125',
      l:'BETA RR 125 2T',
      y:[2020,2021,2022,2023,2024,2025,2026],
      g:[
        {id:'beta-rr-125-gen1', years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'beta-rr-200',
      l:'BETA RR 200 2T',
      y:[2020,2021,2022,2023,2024,2025,2026],
      g:[
        {id:'beta-rr-200-gen1', years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'beta-rr-250',
      l:'BETA RR 250 2T',
      y:[2020,2021,2022,2023,2024,2025,2026],
      g:[
        {id:'beta-rr-250-gen1', years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'beta-rr-300',
      l:'BETA RR 300 2T',
      y:[2020,2021,2022,2023,2024,2025,2026],
      g:[
        {id:'beta-rr-300-gen1', years:[2020,2021,2022,2023,2024,2025,2026]}
      ]

    },

    {
      s:'beta-rr-350',
      l:'BETA RR 350 4T',
      y:[2020,2021,2022,2023,2024,2025,2026],
      g:[
        {id:'beta-rr-350-gen1', years:[2020,2021,2022,2023,2024,2025,2026]}
      ]    
    },

    {
      s:'beta-rr-390',
      l:'BETA RR 390 4T',
      y:[2020,2021,2022,2023,2024,2025,2026],
      g:[
        {id:'beta-rr-390-gen1', years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'beta-rr-430',
      l:'BETA RR 430 4T',
      y:[2020,2021,2022,2023,2024,2025,2026],
      g:[
        {id:'beta-rr-430-gen1', years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'beta-rr-480',
      l:'BETA RR 480 4T',
      y:[2020,2021,2022,2023,2024,2025,2026],
      g:[
        {id:'beta-rr-480-gen1', years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'beta-xtrainer-250',
      l:'BETA XTRAINER 250 2T',
      y:[2020,2021,2022,2023,2024,2025,2026],
      g:[
        {id:'beta-xtrainer-250-gen1', years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'beta-xtrainer-300',
      l:'BETA XTRAINER 300 2T',
      y:[2020,2021,2022,2023,2024,2025,2026],
      g:[
        {id:'beta-xtrainer-300-gen1', years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },
  ],

  'BMW': [

    {
      s:'bmw-f650st-funduro',
      l:'BMW F650ST / FUNDURO',
      y:[1996,1997,1998,1999,2000],

      g:[
        {id:'bmw-f650st-funduro-gen1',years:[1996,1997,1998,1999,2000]}
      ]
    },

    {
      s:'bmw-f-700-gs',
      l:'BMW F 700 GS',
      y:[2013,2014,2015,2016,2017,2018],

      g:[
        {id:'bmw-f-700-gs-gen1',years:[2013,2014,2015,2016,2017,2018]}
      ]
    },

    {
      s:'bmw-f-800-gs',
      l:'BMW F 800 GS',
      y:[2008,2009,2010,2011,2012],

      g:[
        {id:'bmw-f-800-gs-gen1',years:[2008,2009,2010,2011,2012]}
      ]
    },

    {
      s:'bmw-f-850-gs',
      l:'BMW F 850 GS',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'bmw-f-850-gs-gen1',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'bmw-f-900-r',
      l:'BMW F 900 R',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'bmw-f-900-r-gen1',years:[2020,2021,2022,2023,2024]},
        {id:'bmw-f-900-r-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'bmw-r-1200-gs',
      l:'BMW R 1200 GS',
      y:[2004,2005,2006,2007,2008,2009,2010,2011,2012],

      g:[
        {id:'bmw-r-1200-gs-gen1',years:[2004,2005,2006,2007]},
        {id:'bmw-r-1200-gs-gen2',years:[2008,2009,2010]},
        {id:'bmw-r-1200-gs-gen3',years:[2011,2012]}
      ]
    },

    {
      s:'bmw-r-1250-gs',
      l:'BMW R 1250 GS',
      y:[2018,2019,2020,2021,2022,2023,2024],

      g:[
        {id:'bmw-r-1250-gs-gen1',years:[2018,2019,2020,2021]},
        {id:'bmw-r-1250-gs-gen2',years:[2022,2023,2024]}
      ]
    },

    {
      s:'bmw-r-1250-gs-adventure',
      l:'BMW R 1250 GS ADVENTURE',
      y:[2019,2020,2021,2022,2023,2024],

      g:[
        {id:'bmw-r-1250-gs-adventure-gen1',years:[2019,2020,2021]},
        {id:'bmw-r-1250-gs-adventure-gen2',years:[2022,2023,2024]}
      ]
    },

    {
      s:'bmw-s-1000-rr',
      l:'BMW S 1000 RR',
      y:[2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'bmw-s-1000-rr-gen1',years:[2010,2011]},
        {id:'bmw-s-1000-rr-gen2',years:[2012,2013,2014]},
        {id:'bmw-s-1000-rr-gen3',years:[2015,2016,2017,2018]},
        {id:'bmw-s-1000-rr-gen4',years:[2019,2020,2021,2022]},
        {id:'bmw-s-1000-rr-gen5',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'bmw-s-1000-r',
      l:'BMW S 1000 R',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'bmw-s-1000-r-gen1',years:[2014,2015,2016,2017,2018,2019,2020]},
        {id:'bmw-s-1000-r-gen2',years:[2021,2022,2023,2024]},
        {id:'bmw-s-1000-r-gen3',years:[2025,2026]}
      ]
    },

    {
      s:'bmw-s-1000-xr',
      l:'BMW S 1000 XR',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'bmw-s-1000-xr-gen1',years:[2015,2016,2017,2018,2019]},
        {id:'bmw-s-1000-xr-gen2',years:[2020,2021,2022,2023,2024]},
        {id:'bmw-s-1000-xr-gen3',years:[2025,2026]}
      ]
    },

    {
      s:'bmw-r-1250-r',
      l:'BMW R 1250 R',
      y:[2019,2020,2021,2022,2023,2024],

      g:[
        {id:'bmw-r-1250-r-gen1',years:[2019,2020,2021,2022,2023,2024]}
      ]
    },

    {
      s:'bmw-r-1250-rs',
      l:'BMW R 1250 RS',
      y:[2019,2020,2021,2022,2023,2024],

      g:[
        {id:'bmw-r-1250-rs-gen1',years:[2019,2020,2021,2022,2023,2024]}
      ]
    },

    {
      s:'bmw-k-1600-gt',
      l:'BMW K 1600 GT',
      y:[2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'bmw-k-1600-gt-gen1',years:[2011,2012,2013,2014,2015,2016]},
        {id:'bmw-k-1600-gt-gen2',years:[2017,2018,2019,2020,2021]},
        {id:'bmw-k-1600-gt-gen3',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'bmw-r-12',
      l:'BMW R 12',
      y:[2024,2025,2026],

      g:[
        {id:'bmw-r-12-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'bmw-r-12-ninet',
      l:'BMW R 12 NINET',
      y:[2024,2025,2026],

      g:[
        {id:'bmw-r-12-ninet-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'bmw-c-400-gt',
      l:'BMW C 400 GT',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'bmw-c-400-gt-gen1',years:[2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },
  ],

  'CFMOTO': [

    {
      s:'cfmoto-300nk',
      l:'CFMOTO 300NK',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'cfmoto-300nk-gen1',years:[2019,2020,2021]},
        {id:'cfmoto-300nk-gen2',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-300sr',
      l:'CFMOTO 300SR',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'cfmoto-300sr-gen1',years:[2020,2021,2022]},
        {id:'cfmoto-300sr-gen2',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-450nk',
      l:'CFMOTO 450NK',
      y:[2023,2024,2025,2026],

      g:[
        {id:'cfmoto-450nk-gen1',years:[2023,2024]},
        {id:'cfmoto-450nk-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'cfmoto-450sr',
      l:'CFMOTO 450SR',
      y:[2023,2024,2025,2026],

      g:[
        {id:'cfmoto-450sr-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-450sr-s',
      l:'CFMOTO 450SR S',
      y:[2024,2025,2026],

      g:[
        {id:'cfmoto-450sr-s-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-650nk',
      l:'CFMOTO 650NK',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'cfmoto-650nk-gen1',years:[2015,2016,2017,2018,2019]},
        {id:'cfmoto-650nk-gen2',years:[2020,2021,2022,2023]},
        {id:'cfmoto-650nk-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-650mt',
      l:'CFMOTO 650MT',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'cfmoto-650mt-gen1',years:[2017,2018,2019,2020]},
        {id:'cfmoto-650mt-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-650gt',
      l:'CFMOTO 650GT',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'cfmoto-650gt-gen1',years:[2019,2020,2021,2022]},
        {id:'cfmoto-650gt-gen2',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-700cl-x',
      l:'CFMOTO 700CL-X',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'cfmoto-700cl-x-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-700cl-x-sport',
      l:'CFMOTO 700CL-X SPORT',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'cfmoto-700cl-x-sport-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-700mt',
      l:'CFMOTO 700MT',
      y:[2024,2025,2026],

      g:[
        {id:'cfmoto-700mt-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-800nk',
      l:'CFMOTO 800NK',
      y:[2023,2024,2025,2026],

      g:[
        {id:'cfmoto-800nk-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-800nk-advanced',
      l:'CFMOTO 800NK ADVANCED',
      y:[2023,2024,2025,2026],

      g:[
        {id:'cfmoto-800nk-advanced-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-800mt',
      l:'CFMOTO 800MT',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'cfmoto-800mt-gen1',years:[2021,2022,2023]},
        {id:'cfmoto-800mt-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-800mt-sport',
      l:'CFMOTO 800MT SPORT',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'cfmoto-800mt-sport-gen1',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-800mt-touring',
      l:'CFMOTO 800MT TOURING',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'cfmoto-800mt-touring-gen1',years:[2021,2022,2023]},
        {id:'cfmoto-800mt-touring-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-800mt-explore',
      l:'CFMOTO 800MT EXPLORE',
      y:[2023,2024,2025,2026],

      g:[
        {id:'cfmoto-800mt-explore-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'cfmoto-1250tr-g',
      l:'CFMOTO 1250TR-G',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'cfmoto-1250tr-g-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },
  ],

  'COBRA': [

    {
      s:'cobra-cx65',
      l:'COBRA CX65',
      y:[2025,2026],

      g:[
        {id:'cobra-cx65-gen1',years:[2025,2026]}
      ]
    },
  ],

  'DUCATI': [

    {
      s:'ducati-scrambler-800',
      l:'DUCATI SCRAMBLER 800',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ducati-scrambler-800-gen1',years:[2015,2016,2017]},
        {id:'ducati-scrambler-800-gen2',years:[2019,2020,2021,2022]},
        {id:'ducati-scrambler-800-gen3',years:[2023,2024,2025,2026,2027]}
      ]
    },

      {
      s:'ducati-desert-x',
      l:'DUCATI DESERT X',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'ducati-desert-x-gen1',years:[2022,2023,2024,2025,2026]},
         {id:'ducati-desert-x-gen2',years:[2026]}
      ]
    },

    {
      s:'ducati-multisrada-950',
      l:'DUCATI MULTISTRADA 950',
      y:[2017,2018,2019,2020,2021],

      g:[
        {id:'ducati-multisrada-950-gen1',years:[2017,2018,2019,2020,2021]}
      ]
    },

    {
      s:'ducati-multisrada-950-s',
      l:'DUCATI MULTISTRADA 950S',
      y:[2019,2020,2021],

      g:[
        {id:'ducati-multisrada-950s-gen1',years:[2019,2020,2021]}
      ]
    },

    {
      s:'ducati-multisrada-1200',
      l:'DUCATI MULTISTRADA 1200',
      y:[2019,2020,2021],

      g:[
        {id:'ducati-multisrada-1200-gen1',years:[2010,2011,2012,2013,2014,2015,2016,2017]},
        {id:'ducati-multisrada-1200-gen1',years:[2013,2014]},
        {id:'ducati-multisrada-1200-gen1',years:[2015,2016,2017]}
      ]
    },

    {
      s:'ducati-multisrada-1200s',
      l:'DUCATI MULTISTRADA 1200S',
      y:[2013,2014,2015,2016,2017],

      g:[
        {id:'ducati-multisrada-1200s-gen1',years:[2013,2014]},
        {id:'ducati-multisrada-1200s-gen2',years:[2015,2016,2017]}
      ]
    },

    {
      s:'ducati-multisrada-1200-pikes-peak',
      l:'DUCATI MULTISTRADA 1200 PIKES PEAK',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ducati-multisrada-1200-pikes-peak-gen1',years:[2012,2013,2014]},
        {id:'ducati-multisrada-1200-pikes-peak-gen2',years:[2016,2017,2018,2019,2020]},
        {id:'ducati-multisrada-1200-pikes-peak-gen2',years:[2022,2023,2024,2025,2026]},
      ]
    },

    {
      s:'ducati-multisrada-1200-enduro',
      l:'DUCATI MULTISTRADA 1200 ENDURO',
      y:[2016,2017,2018],

      g:[
        {id:'ducati-multisrada-1200-enduro-gen1',years:[2016,2017,2018]},
      ]
    },

    {
      s:'ducati-multisrada-1200-enduro',
      l:'DUCATI MULTISTRADA 1200 ENDURO',
      y:[2016,2017,2018],

      g:[
        {id:'ducati-multisrada-1200-enduro-gen1',years:[2016,2017,2018]},
      ]
    },

    {
      s:'ducati-monster-1200s',
      l:'DUCATI MONSTER 1200S',
      y:[2014,2015,2016,2017,2018,2019,2020,2021],

      g:[
        {id:'ducati-monster-1200s-gen1',years:[2014,2015,2016,2017]},
        {id:'ducati-monster-1200s-gen2',years:[2017,2018,2019,2020,2021]},
      ],
    },

    {
      s:'ducati-monster-1200r',
      l:'DUCATI MONSTER 1200R',
      y:[2016,2017,2018,2019,2020],

      g:[
        {id:'ducati-monster-1200r-gen1',years:[2016,2017,2018,2019,2020]},

      ]
    },

    {
      s:'ducati-supersports',
      l:'DUCATI SUPERSPORT S',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026,2027],

      g:[
        {id:'ducati-supersports-gen1',years:[2017,2018,2019,2020]},
        {id:'ducati-supersports-gen2',years:[2021,2022,2023,2024,2025,2026,2027]},

      ]
    },

    {
      s:'ducati-hypermotard-939',
      l:'DUCATI HYPERMOTARD 939',
      y:[2016,2017,2018],

      g:[
        {id:'ducati-hypermotard-939-gen1',years:[2016,2017,2018]},

      ]
    },

    {
      s:'ducati-hypermotard-939SP',
      l:'DUCATI HYPERMOTARD 939 SP',
      y:[2016,2017,2018],

      g:[
        {id:'ducati-hypermotard-939SP-gen1',years:[2016,2017,2018]},

      ]
    },
  ],

  'FANTIC': [

    {
      s:'fantic-caballero-125',
      l:'FANTIC CABALLERO 125',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'fantic-caballero-125-gen1',years:[2018,2019,2020,2021]},
        {id:'fantic-caballero-125-gen2',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'fantic-caballero-250',
      l:'FANTIC CABALLERO 250',
      y:[2018,2019,2020,2021,2022,2023,2024]
    },

    {
      s:'fantic-caballero-500',
      l:'FANTIC CABALLERO 500',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'fantic-caballero-500-gen1',years:[2018,2019,2020,2021]},
        {id:'fantic-caballero-500-gen2',years:[2022,2023,2024]},
        {id:'fantic-caballero-500-gen3',years:[2025,2026]}
      ]
    },

    {
      s:'fantic-caballero-700',
      l:'FANTIC CABALLERO 700',
      y:[2023,2024,2025,2026],

      g:[
        {id:'fantic-caballero-700-gen1',years:[2023,2024]},
        {id:'fantic-caballero-700-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'fantic-xe-125',
      l:'FANTIC XE 125',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'fantic-xe-125-gen1',years:[2020,2021,2022,2023]},
        {id:'fantic-xe-125-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'fantic-xe-300',
      l:'FANTIC XE 300',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'fantic-xe-300-gen1',years:[2022,2023]},
        {id:'fantic-xe-300-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'fantic-xef-125',
      l:'FANTIC XEF 125',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'fantic-xef-125-gen1',years:[2021,2022,2023]},
        {id:'fantic-xef-125-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'fantic-xef-250',
      l:'FANTIC XEF 250',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'fantic-xef-250-gen1',years:[2021,2022,2023]},
        {id:'fantic-xef-250-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'fantic-xef-450',
      l:'FANTIC XEF 450',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'fantic-xef-450-gen1',years:[2022,2023]},
        {id:'fantic-xef-450-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'fantic-xef-450-rally',
      l:'FANTIC XEF 450 RALLY',
      y:[2023,2024,2025,2026]
    },

    {
      s:'fantic-xmf-125',
      l:'FANTIC XMF 125',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'fantic-xmf-125-gen1',years:[2021,2022,2023]},
        {id:'fantic-xmf-125-gen2',years:[2024,2025,2026]}
      ]
    },
  ],

  'GASGAS': [

    {
      s:'gas-gas-mc50',
      l:'GAS GAS MC50',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-mc50-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-mc65',
      l:'GAS GAS MC65',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-mc65-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-mc-e5',
      l:'GAS GAS MC-E5',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-mc-e5-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-ec-125',
      l:'GASGAS EC 125',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-ec-125-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-ec-125-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-ec-250',
      l:'GASGAS EC 250',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-ec-250-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-ec-250-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-ec-300',
      l:'GASGAS EC 300',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-ec-300-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-ec-300-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-ec-250f',
      l:'GASGAS EC 250F',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-ec-250f-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-ec-250f-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-ec-350f',
      l:'GASGAS EC 350F',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-ec-350f-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-ec-350f-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-ec-450f',
      l:'GASGAS EC 450F',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-ec-450f-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-ec-450f-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-ex-250',
      l:'GASGAS EX 250',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-ex-250-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-ex-250-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-ex-300',
      l:'GASGAS EX 300',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-ex-300-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-ex-300-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-ex-250f',
      l:'GASGAS EX 250F',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-ex-250f-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-ex-250f-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-ex-350f',
      l:'GASGAS EX 350F',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-ex-350f-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-ex-350f-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-ex-450f',
      l:'GASGAS EX 450F',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-ex-450f-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-ex-450f-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-mc-125',
      l:'GASGAS MC 125',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-mc-125-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-mc-125-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-mc-250',
      l:'GASGAS MC 250',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-mc-250-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-mc-250-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-mc-250f',
      l:'GASGAS MC 250F',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-mc-250f-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-mc-250f-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-mc-350f',
      l:'GASGAS MC 350F',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-mc-350f-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-mc-350f-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-mc-450f',
      l:'GASGAS MC 450F',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-mc-450f-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-mc-450f-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-mc-65',
      l:'GASGAS MC 65',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-mc-65-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-mc-65-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'gas-gas-mc-85',
      l:'GASGAS MC 85',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'gas-gas-mc-85-gen1',years:[2021,2022,2023]},
        {id:'gas-gas-mc-85-gen2',years:[2024,2025,2026]}
      ]
    },
  ],

  'HARLEY DAVIDSON': [

    {
      s:'harley-davidson-sportster-883',
      l:'HARLEY-DAVIDSON SPORTSTER 883',
      y:[2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020],

      g:[
        {id:'harley-davidson-sportster-883-gen1',years:[2004,2005,2006,2007,2008,2009]},
        {id:'harley-davidson-sportster-883-gen2',years:[2010,2011,2012,2013,2014,2015,2016]},
        {id:'harley-davidson-sportster-883-gen3',years:[2017,2018,2019,2020]}
      ]
    },

    {
      s:'harley-davidson-sportster-1200',
      l:'HARLEY-DAVIDSON SPORTSTER 1200',
      y:[2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020],

      g:[
        {id:'harley-davidson-sportster-1200-gen1',years:[2004,2005,2006,2007,2008,2009]},
        {id:'harley-davidson-sportster-1200-gen2',years:[2010,2011,2012,2013,2014,2015,2016]},
        {id:'harley-davidson-sportster-1200-gen3',years:[2017,2018,2019,2020]}
      ]
    },

    {
      s:'harley-davidson-sportster-s',
      l:'HARLEY-DAVIDSON SPORTSTER S',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'harley-davidson-sportster-s-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'harley-davidson-nightster',
      l:'HARLEY-DAVIDSON NIGHTSTER',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'harley-davidson-nightster-gen1',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'harley-davidson-street-500',
      l:'HARLEY-DAVIDSON STREET 500',
      y:[2014,2015,2016,2017,2018,2019,2020,2021],

      g:[
        {id:'harley-davidson-street-500-gen1',years:[2014,2015,2016,2017,2018,2019,2020,2021]}
      ]
    },

    {
      s:'harley-davidson-street-750',
      l:'HARLEY-DAVIDSON STREET 750',
      y:[2014,2015,2016,2017,2018,2019,2020,2021],

      g:[
        {id:'harley-davidson-street-750-gen1',years:[2014,2015,2016,2017,2018,2019,2020,2021]}
      ]
    },

    {
      s:'harley-davidson-iron-883',
      l:'HARLEY-DAVIDSON IRON 883',
      y:[2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021],

      g:[
        {id:'harley-davidson-iron-883-gen1',years:[2009,2010,2011,2012,2013,2014,2015,2016]},
        {id:'harley-davidson-iron-883-gen2',years:[2017,2018,2019,2020,2021]}
      ]
    },

    {
      s:'harley-davidson-fat-bob',
      l:'HARLEY-DAVIDSON FAT BOB',
      y:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'harley-davidson-fat-bob-gen1',years:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017]},
        {id:'harley-davidson-fat-bob-gen2',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'harley-davidson-fat-boy',
      l:'HARLEY-DAVIDSON FAT BOY',
      y:[1990,1991,1992,1993,1994,1995,1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'harley-davidson-fat-boy-gen1',years:[1990,1991,1992,1993,1994,1995,1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007]},
        {id:'harley-davidson-fat-boy-gen2',years:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017]},
        {id:'harley-davidson-fat-boy-gen3',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'harley-davidson-low-rider',
      l:'HARLEY-DAVIDSON LOW RIDER',
      y:[1977,1978,1979,1980,1981,1982,1983,1984,1985,1986,1987,1988,1989,1990,1991,1992,1993,1994,1995,1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'harley-davidson-low-rider-gen1',years:[1977,1978,1979,1980,1981,1982,1983,1984,1985,1986,1987,1988,1989,1990,1991,1992,1993,1994,1995,1996,1997,1998,1999,2000]},
        {id:'harley-davidson-low-rider-gen2',years:[2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017]},
        {id:'harley-davidson-low-rider-gen3',years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'harley-davidson-low-rider-s',
      l:'HARLEY-DAVIDSON LOW RIDER S',
      y:[2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'harley-davidson-low-rider-s-gen1',years:[2016,2017,2018,2019,2020]},
        {id:'harley-davidson-low-rider-s-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'harley-davidson-street-bob',
      l:'HARLEY-DAVIDSON STREET BOB',
      y:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'harley-davidson-street-bob-gen1',years:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017]},
        {id:'harley-davidson-street-bob-gen2',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'harley-davidson-pan-america-1250',
      l:'HARLEY-DAVIDSON PAN AMERICA 1250',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'harley-davidson-pan-america-1250-gen1',years:[2021,2022,2023,2024]},
        {id:'harley-davidson-pan-america-1250-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'harley-davidson-pan-america-1250-special',
      l:'HARLEY-DAVIDSON PAN AMERICA 1250 SPECIAL',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'harley-davidson-pan-america-1250-special-gen1',years:[2021,2022,2023,2024]},
        {id:'harley-davidson-pan-america-1250-special-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'harley-davidson-night-rod-special',
      l:'HARLEY-DAVIDSON NIGHT ROD SPECIAL',
      y:[2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017],

      g:[
        {id:'harley-davidson-night-rod-special-gen1',years:[2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017]}
      ]
    },

    {
      s:'harley-davidson-v-rod',
      l:'HARLEY-DAVIDSON V-ROD',
      y:[2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017],

      g:[
        {id:'harley-davidson-v-rod-gen1',years:[2002,2003,2004,2005,2006,2007]},
        {id:'harley-davidson-v-rod-gen2',years:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017]}
      ]
    },

    {
      s:'harley-davidson-road-glide',
      l:'HARLEY-DAVIDSON ROAD GLIDE',
      y:[1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'harley-davidson-road-glide-gen1',years:[1998,1999,2000,2001,2002,2003,2004,2005]},
        {id:'harley-davidson-road-glide-gen2',years:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015]},
        {id:'harley-davidson-road-glide-gen3',years:[2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'harley-davidson-street-glide',
      l:'HARLEY-DAVIDSON STREET GLIDE',
      y:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'harley-davidson-street-glide-gen1',years:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015]},
        {id:'harley-davidson-street-glide-gen2',years:[2016,2017,2018,2019,2020,2021,2022,2023]},
        {id:'harley-davidson-street-glide-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'harley-davidson-electra-glide',
      l:'HARLEY-DAVIDSON ELECTRA GLIDE',
      y:[1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017],

      g:[
        {id:'harley-davidson-electra-glide-gen1',years:[1999,2000,2001,2002,2003,2004,2005]},
        {id:'harley-davidson-electra-glide-gen2',years:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017]}
      ]
    },

    {
      s:'harley-davidson-heritage-classic',
      l:'HARLEY-DAVIDSON HERITAGE CLASSIC',
      y:[1987,1988,1989,1990,1991,1992,1993,1994,1995,1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'harley-davidson-heritage-classic-gen1',years:[1987,1988,1989,1990,1991,1992,1993,1994,1995,1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007]},
        {id:'harley-davidson-heritage-classic-gen2',years:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017]},
        {id:'harley-davidson-heritage-classic-gen3',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },
  ],

  'HONDA': [

    {
      s:'honda-msx125-grom',
      l:'HONDA MSX125 (GROM)',
      y:[1980,1981,1982],

      g:[
        {id:'honda-msx125-grom-gen1',years:[2013,2014,2015]},
        {id:'honda-msx125-grom-gen2',years:[2016,2017,2018,2019,2020]},
        {id:'honda-msx125-grom-gen3',years:[2021,2022,2023,2024,2025,2026,2027]},
      ]
    },

     {
      s:'honda-msz125-monkey',
      l:'HONDA MSZ125 (MONKEY)',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026,2027],

      g:[
        {id:'honda-msz125-monkey-gen1',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026,2027]},
      ]
    },

    {
      s:'honda-cb900-custom',
      l:'HONDA CB900 CUSTOM',
      y:[1980,1981,1982],

      g:[
        {id:'honda-cb900-custom-gen1',years:[1980,1981,1982]},
      ]
    },

    {
      s:'honda-crf230f',
      l:'HONDA CRF230F',
      y:[2003,2004,2005,2006,2007],

      g:[
        {id:'honda-crf230f-gen1',years:[2003,2004,2005]},
        {id:'honda-crf230f-gen1',years:[2006,2007,2008]},
        {id:'honda-crf230f-gen1',years:[2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019]}
      ]
    },

    {
      s:'honda-crf230f-enduro',
      l:'HONDA CRF230F ENDURO',
      y:[2008,2009,2010],

      g:[
        {id:'honda-crf230f-enduro-gen1',years:[2008,2009,2010]}
      ]
    },

    {
      s:'honda-cx500-turbo',
      l:'HONDA CX500 TURBO',
      y:[1982,1983,1984,1985,1986],

      g:[
        {id:'honda-cx500-turbo-gen1',years:[1982,1983,1984,1985,1986]}
      ]
    },

    {
      s:'honda-cx650',
      l:'HONDA CX650',
      y:[1983,1984,1985,1986],

      g:[
        {id:'honda-cx650-gen1',years:[1983,1984,1985,1986]}
      ]
    },

    {
      s:'honda-ns400rf-rg',
      l:'HONDA NS400RF-RG',
      y:[1985,1986,1987,1988],

      g:[
        {id:'honda-ns400rf-rg-gen1',years:[1985,1986,1987,1988]}
      ]
    },

    {
      s:'honda-vf500',
      l:'HONDA VF500',
      y:[1984,1985,1986,1987,1988,1989],

      g:[
        {id:'honda-vf500-gen1',years:[1984,1985,1986,1987,1988,1989]}
      ]
    },

    {
      s:'honda-vf700',
      l:'HONDA VF700',
      y:[1984,1985,1986,1987,1988,1989],

      g:[
        {id:'honda-vf700-gen1',years:[1984,1985,1986,1987,1988,1989]}
      ]
    },

    {
      s:'honda-vfr400r-nc24',
      l:'HONDA VFR400R NC24',
      y:[1987,1988],

      g:[
        {id:'honda-vfr400r-nc24-gen1',years:[1987,1988]}
      ]
    },

    {
      s:'honda-vfr750f-rc24',
      l:'HONDA VFR750F RC24',
      y:[1986,1987],

      g:[
        {id:'honda-vfr750f-rc24-gen1',years:[1986,1987]}
      ]
    },

    {
      s:'honda-vt750c-shadow',
      l:'HONDA VT750C SHADOW',
      y:[2004,2005,2006,2007,2008,2009,2010,2011],

      g:[
        {id:'honda-vt750c-shadow-gen1',years:[2004,2005,2006,2007,2008,2009,2010,2011]}
      ]
    },

    {
      s:'honda-xr250r',
      l:'HONDA XR250R',
      y:[1996,1997,1998,1999,2000,2001,2002,2003,2004],

      g:[
        {id:'honda-xr250r-gen1',years:[1996,1997,1998,1999,2000,2001,2002,2003,2004]}
      ]
    },

    {
      s:'honda-xr350rd-re',
      l:'HONDA XR350RD-RE',
      y:[1983,1984],

      g:[
        {id:'honda-xr350rd-re-gen1',years:[1983,1984]}
      ]
    },

    {
      s:'honda-xl500r',
      l:'HONDA XL500R',
      y:[1981,1982,1983,1984,1985,1986],

      g:[
        {id:'honda-xl500r-gen1',years:[1981,1982,1983,1984,1985,1986]}
      ]
    },

    {
      s:'honda-xr250r-rb',
      l:'HONDA XR250R-RB',
      y:[1981,1982],

      g:[
        {id:'honda-xr250r-rb-gen1',years:[1981,1982]}
      ]
    },

    {
      s:'honda-cb500-pc26',
      l:'HONDA CB500 PC26',
      y:[1994,1995],

      g:[
        {id:'honda-cb500-pc26-gen1',years:[1994,1995]}
      ]
    },

    {
      s:'honda-cb500-pc32',
      l:'HONDA CB500 PC32',
      y:[1996,1997,1998,1999,2000,2001,2002,2003],

      g:[
        {id:'honda-cb500-pc32-gen1',years:[1996,1997,1998,1999,2000,2001,2002,2003]}
      ]
    },

    {
      s:'honda-cbr250rr',
      l:'HONDA CBR250RR',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-cbr250rr-gen1',years:[2017,2018,2019,2020]},
        {id:'honda-cbr250rr-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'honda-cr85r-sw',
      l:'HONDA CR85R SW',
      y:[1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007],

      g:[
        {id:'honda-cr85r-sw-gen1',years:[1996,1997,1998,1999,2000,2001,2002]},
        {id:'honda-cr85r-sw-gen2',years:[2003,2004,2005,2006,2007]}
      ]
    },

    {
      s:'honda-cr85r-lw',
      l:'HONDA CR85R LW',
      y:[1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007],

      g:[
        {id:'honda-cr85r-lw-gen1',years:[1996,1997,1998,1999,2000,2001,2002]},
        {id:'honda-cr85r-lw-gen2',years:[2003,2004,2005,2006,2007]}
      ]
    },

    {
      s:'honda-crf150r-sw',
      l:'HONDA CRF150R SW',
      y:[2007,2008],

      g:[
        {id:'honda-crf150r-sw-gen1',years:[2007,2008]}
      ]
    },

    {
      s:'honda-crf150r-lw',
      l:'HONDA CRF150R LW',
      y:[2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-crf150r-lw-gen1',years:[2007,2008,2009,2010,2011,2012]},
        {id:'honda-crf150r-lw-gen2',years:[2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'honda-cbr250rr',
      l:'HONDA CBR250RR',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-cbr250rr-gen1',years:[2017,2018,2019,2020,2021,2022]},
        {id:'honda-cbr250rr-gen2',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'honda-cbr500r-pc44',
      l:'HONDA CBR500R PC44',
      y:[2013,2014,2015,2016],

      g:[
        {id:'honda-cbr500r-pc44-gen1',years:[2013,2014,2015,2016]},
      ]
    },

       {
      s:'honda-cbr500r-pc57',
      l:'HONDA CBR500R PC57',
      y:[2017,2018],

      g:[
        {id:'honda-cbr500r-pc57-gen1',years:[2017,2018]},
      ]
    },

    {
      s:'honda-cbr600-f-pc19',
      l:'HONDA CBR600 F PC19',
      y:[1987,1988],

      g:[
        {id:'honda-cbr600-f-pc19-gen1',years:[1987,1988]}
      ]
    },

    {
      s:'honda-cbr600-f-pc23',
      l:'HONDA CBR600 F PC23',
      y:[1987,1988],

      g:[
        {id:'honda-cbr600-f-pc23-gen1',years:[1987,1988]}
      ]
    },

    {
      s:'honda-cbr600rr',
      l:'HONDA CBR600RR',
      y:[2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-cbr600rr-gen1',years:[2003,2004]},
        {id:'honda-cbr600rr-gen2',years:[2005,2006]},
        {id:'honda-cbr600rr-gen3',years:[2007,2008]},
        {id:'honda-cbr600rr-gen4',years:[2009,2010,2011,2012]},
        {id:'honda-cbr600rr-gen5',years:[2013,2014,2015,2016,2017,2018,2019,2020,2021]}, 
        {id:'honda-cbr600rr-gen6',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'honda-cbr650r',
      l:'HONDA CBR650R',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-cbr650r-gen1',years:[2019,2020]},
        {id:'honda-cbr650r-gen2',years:[2021,2022,2023]},
        {id:'honda-cbr650r-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'honda-cbr1000rr-sc57',
      l:'HONDA CBR1000RR SC57',
      y:[2004,2005,2006,2007],

      g:[
        {id:'honda-cbr1000rr-sc57-gen1',years:[2004,2005,2006,2007]},
      ]
    
    },

    {
      s:'honda-cbr1000rr-sc59',
      l:'HONDA CBR1000RR SC59',
      y:[2008,2009,2010,2011],

      g:[
        {id:'honda-cbr1000rr-sc59-gen1',years:[2008,2009,2010,2011]},
        {id:'honda-cbr1000rr-sc59-gen2',years:[2012,2013,2014,2015,2016]},
      ]
    },

    {
      s:'honda-cbr1000rr-sc77',
      l:'HONDA CBR1000RR SC77',
      y:[2017,2018,2019],

      g:[
        {id:'honda-cbr1000rr-sc77-gen1',years:[2017,2018,2019]},
      ]
    },

    {
      s:'honda-cbr1000rr-r-fireblade',
      l:'HONDA CBR1000RR-R FIREBLADE',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-cbr1000rr-r-fireblade-gen1',years:[2020,2021,2022,2023,2024]},
        {id:'honda-cbr1000rr-r-fireblade-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'honda-cb500f-pc45',
      l:'HONDA CB500F PC45',
      y:[2013,2014,2015,2016],

      g:[
        {id:'honda-cb500f-pc45-gen1',years:[2013,2014,2015,2016]},
      ]
    },

    {
      s:'honda-cb500f-pc58',
      l:'HONDA CB500F PC58',
      y:[2017,2018],

      g:[
        {id:'honda-cb500f-pc58-gen1',years:[2017,2018]},
      ]
    },

    {
      s:'honda-cb500x-pc46',
      l:'HONDA CB500X PC46',
      y:[2013,2014,2015,2016],

      g:[
        {id:'honda-cb500x-pc46-gen1',years:[2013,2014,2015,2016]},
      ]
    },

    {
      s:'honda-cb500x-pc59',
      l:'HONDA CB500X PC59',
      y:[2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-cb500x-pc59-gen1',years:[2013,2014,2015,2016,2017,2018]},
      ]
    },

    {
      s:'honda-cb1000r',
      l:'HONDA CB1000R',
      y:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-cb1000r-gen1',years:[2008,2009,2010,2011,2012,2013,2014,2015,2016]},
        {id:'honda-cb1000r-gen2',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'honda-nc750x',
      l:'HONDA NC750X',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-nc750x-gen1',years:[2014,2015]},
        {id:'honda-nc750x-gen2',years:[2016,2017,2018,2019,2020]},
        {id:'honda-nc750x-gen3',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'honda-crf250l',
      l:'HONDA CRF250L',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020],

      g:[
        {id:'honda-crf250l-gen1',years:[2012,2013,2014,2015,2016]},
        {id:'honda-crf250l-gen2',years:[2017,2018,2019,2020]},
      ]
    },

    {
      s:'honda-crf300l',
      l:'HONDA CRF300L',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-crf300l-gen1',years:[2021,2022,2023,2024]},
        {id:'honda-crf300l-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'honda-crf300l-rally',
      l:'HONDA CRF300L RALLY',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-crf300l-rally-gen1',years:[2021,2022,2023,2024]},
        {id:'honda-crf300l-rally-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'honda-crf450l',
      l:'HONDA CRF450L',
      y:[2019,2020],

      g:[
        {id:'honda-crf450l-gen1',years:[2019,2020]}
      ]
    },

    {
      s:'honda-crf450rl',
      l:'HONDA CRF450RL',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-crf450rl-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'honda-crf1000l-africa-twin',
      l:'HONDA CRF1000L AFRICA TWIN',
      y:[2016,2017,2018,2019],

      g:[
        {id:'honda-crf1000l-africa-twin-gen1',years:[2016,2017]},
        {id:'honda-crf1000l-africa-twin-gen2',years:[2018,2019]}
      ]
    },

       {
      s:'honda-crf1000l-africa-twin-adventure-sports',
      l:'HONDA CRF1000L AFRICA TWIN ADVENTURE SPORTS',
      y:[2018,2019],

      g:[
        {id:'honda-crf1000l-africa-twin-adventure-sports-gen1',years:[2018,2019]},
      ]
    },

    {
      s:'honda-crf1100l-africa-twin',
      l:'HONDA CRF1100L AFRICA TWIN',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-crf1100l-africa-twin-gen1',years:[2020,2021,2022,2023]},
        {id:'honda-crf1100l-africa-twin-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'honda-crf1100l-africa-twin-adventure-sports',
      l:'HONDA CRF1100L AFRICA TWIN ADVENTURE SPORTS',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-crf1100l-africa-twin-adventure-sports-gen1',years:[2020,2021,2022,2023]},
        {id:'honda-crf1100l-africa-twin-adventure-sports-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'honda-gold-wing-GL1500A',
      l:'HONDA GOLD WING (GL1500A)',
      y:[1991,1992,1993,1994,1995,1996,1997],

      g:[
        {id:'honda-gold-wing-GL1500A-gen1',years:[1991,1992,1993,1994,1995,1996,1997]}
      ]
    },

      {
      s:'honda-gold-wing-GL1800',
      l:'HONDA GOLD WING (GL1800)',
      y:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023],

      g:[
        {id:'honda-gold-wing-GL1800-gen1',years:[2006,2007,2008,2009,2010]},
        {id:'honda-gold-wing-GL1800-gen2',years:[2012,2013,2014,2015,2016,2017]},
        {id:'honda-gold-wing-GL1800-gen3',years:[2018,2019,2020,2021,2022,2023]}
      ]
    },

    {
      s:'honda-rebel-500',
      l:'HONDA REBEL 500',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-rebel-500-gen1',years:[2017,2018,2019]},
        {id:'honda-rebel-500-gen2',years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'honda-rebel-1100',
      l:'HONDA REBEL 1100',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-rebel-1100-gen1',years:[2021,2022,2023]},
        {id:'honda-rebel-1100-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'honda-x-adv',
      l:'HONDA X-ADV',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'honda-x-adv-gen1',years:[2017,2018,2019,2020]},
        {id:'honda-x-adv-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },
  ],

  'HUSQVARNA': [

    {
      s:'husqvarna-svartpilen-250',
      l:'HUSQVARNA SVARTPILEN 250',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'husqvarna-svartpilen-250-gen1',years:[2020,2021,2022,2023]},
        {id:'husqvarna-svartpilen-250-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'husqvarna-vitpilen-250',
      l:'HUSQVARNA VITPILEN 250',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'husqvarna-vitpilen-250-gen1',years:[2020,2021,2022,2023]},
        {id:'husqvarna-vitpilen-250-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'husqvarna-svartpilen-401',
      l:'HUSQVARNA SVARTPILEN 401',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'husqvarna-svartpilen-401-gen1',years:[2018,2019,2020,2021,2022,2023]},
        {id:'husqvarna-svartpilen-401-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'husqvarna-vitpilen-401',
      l:'HUSQVARNA VITPILEN 401',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'husqvarna-vitpilen-401-gen1',years:[2018,2019,2020,2021,2022,2023]},
        {id:'husqvarna-vitpilen-401-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'husqvarna-enduro-701',
      l:'HUSQVARNA ENDURO 701',
      y:[2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026,2027],

      g:[
        {id:'husqvarna-enduro-701-gen1',years:[2016,2017,2018]},
        {id:'husqvarna-enduro-701-gen2',years:[2019]},
        {id:'husqvarna-enduro-701-gen3',years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'husqvarna-norden-901',
      l:'HUSQVARNA NORDEN 901',
      y:[2022,2023,2024,2025,2026,2027],

      g:[
        {id:'husqvarna-norden-901-gen1',years:[2022,2023,2024,2025,2026,2027]},
      ]
    },

    {
      s:'husqvarna-te-250',
      l:'HUSQVARNA TE 250',
      y:[2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'husqvarna-te-250-gen1',years:[2010]},
        {id:'husqvarna-te-250-gen2',years:[2011,2012,2013]},
        {id:'husqvarna-te-250-gen3',years:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023]},
        {id:'husqvarna-te-250-gen4',years:[2024,2025,2026]}
      ]
    },

    {
      s:'husqvarna-te-300',
      l:'HUSQVARNA TE 300',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'husqvarna-te-300-gen1',years:[2014,2015,2016]},
        {id:'husqvarna-te-300-gen2',years:[2017,2018,2019,2020,2021,2022,2023]},
        {id:'husqvarna-te-300-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'husqvarna-fe-250',
      l:'HUSQVARNA FE 250',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'husqvarna-fe-250-gen1',years:[2014,2015,2016]},
        {id:'husqvarna-fe-250-gen2',years:[2017,2018,2019,2020,2021,2022,2023]},
        {id:'husqvarna-fe-250-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'husqvarna-fe-350',
      l:'HUSQVARNA FE 350',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'husqvarna-fe-350-gen1',years:[2014,2015,2016]},
        {id:'husqvarna-fe-350-gen2',years:[2017,2018,2019]},
        {id:'husqvarna-fe-350-gen3',years:[2020,2021,2022,2023]},
        {id:'husqvarna-fe-350-gen4',years:[2024,2025,2026]},
      ]
    },

    {
      s:'husqvarna-tc-250',
      l:'HUSQVARNA TC 250',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'husqvarna-tc-250-gen1',years:[2015,2016]},
        {id:'husqvarna-tc-250-gen2',years:[2017,2018,2019,2020,2021,2022]},
        {id:'husqvarna-tc-250-gen3',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'husqvarna-fc-250',
      l:'HUSQVARNA FC 250',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'husqvarna-fc-250-gen1',years:[2014,2015,2016,2017,2018,2019,2020]},
        {id:'husqvarna-fc-250-gen2',years:[2021,2022]},
        {id:'husqvarna-fc-250-gen3',years:[2023,2024,2025,2026]},
      ]
    },

    {
      s:'husqvarna-fc-350',
      l:'HUSQVARNA FC 350',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'husqvarna-fc-350-gen1',years:[2014,2015,2016,2017]},
        {id:'husqvarna-fc-350-gen2',years:[2018,2019,2020]},
        {id:'husqvarna-fc-350-gen3',years:[2021,2022]},
        {id:'husqvarna-fc-350-gen4',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'husqvarna-fc-450',
      l:'HUSQVARNA FC 450',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'husqvarna-fc-450-gen1',years:[2014,2015,2016]},
        {id:'husqvarna-fc-450-gen2',years:[2017,2018,2019,2020,2021,2022]},
        {id:'husqvarna-fc-450-gen3',years:[2023,2024,2025,2026]},
      ]
    },
  ],

  'INDIAN': [

    {
      s:'indian-scout',
      l:'INDIAN SCOUT',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'indian-scout-gen1',years:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024]},
        {id:'indian-scout-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'indian-scout-sixty',
      l:'INDIAN SCOUT SIXTY',
      y:[2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'indian-scout-sixty-gen1',years:[2016,2017,2018,2019,2020,2021,2022,2023,2024]},
        {id:'indian-scout-sixty-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'indian-scout-bobber',
      l:'INDIAN SCOUT BOBBER',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'indian-scout-bobber-gen1',years:[2018,2019,2020,2021,2022,2023,2024]},
        {id:'indian-scout-bobber-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'indian-chief',
      l:'INDIAN CHIEF',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'indian-chief-gen1',years:[2014,2015,2016,2017,2018,2019,2020]},
        {id:'indian-chief-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'indian-chief-bobber',
      l:'INDIAN CHIEF BOBBER',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'indian-chief-bobber-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'indian-chieftain',
      l:'INDIAN CHIEFTAIN',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'indian-chieftain-gen1',years:[2014,2015,2016,2017,2018,2019,2020]},
        {id:'indian-chieftain-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'indian-roadmaster',
      l:'INDIAN ROADMASTER',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'indian-roadmaster-gen1',years:[2015,2016,2017,2018,2019,2020]},
        {id:'indian-roadmaster-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'indian-ftr-1200',
      l:'INDIAN FTR 1200',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'indian-ftr-1200-gen1',years:[2019,2020,2021]},
        {id:'indian-ftr-1200-gen2',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'indian-ftr-r-carbon',
      l:'INDIAN FTR R CARBON',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'indian-ftr-r-carbon-gen1',years:[2020,2021]},
        {id:'indian-ftr-r-carbon-gen2',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'indian-ftr-sport',
      l:'INDIAN FTR SPORT',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'indian-ftr-sport-gen1',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'indian-pursuit',
      l:'INDIAN PURSUIT',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'indian-pursuit-gen1',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'indian-challenger',
      l:'INDIAN CHALLENGER',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'indian-challenger-gen1',years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },
  ],

  'K-TECH': [

    {
      s:'ktm-wp-35mm-50cc-ords',
      l:'K-TECH ORDS - WP 35MM 50CC',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-wp-35mm-50cc-ords-gen1',years:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktm-wp-35mm-65cc-ords',
      l:'K-TECH ORDS - WP 35MM 65CC',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-wp-35mm-65cc-ords-gen1',years:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktech-razor-lite',
      l:'K-TECH RAZOR LITE',

      g:[
        {id:'ktech-razor-lite-gen1',years:[]}
      ]
    },

    {
      s:'ktech-razor',
      l:'K-TECH RAZOR',

      g:[
        {id:'ktech-razor-gen1',years:[]}
      ]
    },

    {
      s:'ktech-razor-r-lite',
      l:'K-TECH RAZOR-R LITE',

      g:[
        {id:'ktech-razor-r-lite-gen1',years:[]}
      ]
    },

    {
      s:'ktech-razor-r-lite-evo',
      l:'K-TECH RAZOR-R LITE EVO',

      g:[
        {id:'ktech-razor-r-lite-evo-gen1',years:[]}
      ]
    },

    {
      s:'ktech-razor-r',
      l:'K-TECH RAZOR-R',

      g:[
        {id:'ktech-razor-r-gen1',years:[]}
      ]
    },

    {
      s:'ktech-razor-rr',
      l:'K-TECH RAZOR-RR',

      g:[
        {id:'ktech-razor-rr-gen1',years:[]}
      ]
    },

    {
      s:'ktech-dds-lite',
      l:'K-TECH DDS LITE',

      g:[
        {id:'ktech-dds-lite-gen1',years:[]}
      ]
    },

    {
      s:'ktech-dds-pro',
      l:'K-TECH DDS PRO',

      g:[
        {id:'ktech-dds-pro-gen1',years:[]}
      ]
    },

    {
      s:'ktech-trds',
      l:'K-TECH TRDS',

      g:[
        {id:'ktech-trds-gen1',years:[]}
      ]
    },

    {
      s:'ktech-trds-r',
      l:'K-TECH TRDS-R',

      g:[
        {id:'ktech-trds-r-gen1',years:[]}
      ]
    },
  ],

  'KAWASAKI': [

    {
      s:'kawasaki-zx-6r',
      l:'KAWASAKI ZX-6R',
      y:[1995,1996,1997,1998,1999,2000,2001,2002,2007,2008,2009,2010,2011,2012],
      g:[
        {id:'kawasaki-zx-6r-gen1',years:[1995,1996,1997]},
        {id:'kawasaki-zx-6r-gen2',years:[1998,1999]},
        {id:'kawasaki-zx-6r-gen3',years:[2000,2001,2002]},
        {id:'kawasaki-zx-6r-gen6',years:[2007,2008]},
        {id:'kawasaki-zx-6r-gen7',years:[2009,2010,2011,2012]},
      ]
    },

    {
      s:'kawasaki-zx-6r-636',
      l:'KAWASAKI ZX-6R 636',
      y:[2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026,2027],
      g:[
        {id:'kawasaki-zx-6r-636-gen1',years:[2003,2004]},
        {id:'kawasaki-zx-6r-636-gen2',years:[2005,2006]},
        {id:'kawasaki-zx-6r-636-gen3',years:[2013,2014,2015,2016,2017,2018]},
        {id:'kawasaki-zx-6r-636-gen4',years:[2019,2020,2021,2022,2023]},
        {id:'kawasaki-zx-6r-636-gen5',years:[2024,2025,2026,2027]},
      ]
    },

    {
      s:'kawasaki-zx-6rr',
      l:'KAWASAKI ZX-6RR',
      y:[2005,2006],

      g:[
        {id:'kawasaki-zx-6rr-gen1',years:[2005,2006]}
      ]
    },

    {
      s:'kawasaki-z750-s',
      l:'KAWASAKI Z750 S',
      y:[2004,2005,2006],

      g:[
        {id:'kawasaki-z750-s-gen1',years:[2004,2005,2006]}
      ]
    },

    {
      s:'kawasaki-zxr750-r',
      l:'KAWASAKI ZXR750 R',
      y:[2011,2012,2013,2014],

      g:[
        {id:'kawasaki-zxr750-r-gen1',years:[2011,2012,2013,2014]}
      ]
    },

    {
      s:'kawasaki-zxr750-l',
      l:'KAWASAKI ZXR750 L',
      y:[2004,2005,2006],

      g:[
        {id:'kawasaki-zxr750-l-gen1',years:[2004,2005,2006]}
      ]
    },

    {
      s:'kawasaki-vulcan-650s',
      l:'KAWASAKI VULCAN 650S',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-vulcan-650s-gen1',years:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-klr650-e',
      l:'KAWASAKI KLR650 E',
      y:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-klr650-e-gen1',years:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018]},
        {id:'kawasaki-klr650-e-gen2',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-er-6n',
      l:'KAWASAKI ER-6N',
      y:[2006,2007,2008,2009,2010,2011,2013,2014,2015],

      g:[
        {id:'kawasaki-er-6n-gen1',years:[2006,2007,2008]},
        {id:'kawasaki-er-6n-gen2',years:[2009,2010,2011]},
        {id:'kawasaki-er-6n-gen3',years:[2013,2014,2015,2016,2017]}
      ]
    },

    {
      s:'kawasaki-er-6f',
      l:'KAWASAKI ER-6F',
      y:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016],

      g:[
        {id:'kawasaki-er-6f-gen1',years:[2006,2007,2008,2009]},
        {id:'kawasaki-er-6f-gen2',years:[2010,2011,2012,2013]},
        {id:'kawasaki-er-6f-gen3',years:[2014,2015,2016]}
      ]
    },

    {
      s:'kawasaki-en500',
      l:'KAWASAKI EN500',
      y:[1996,1997,1998,1999,2000,2001,2002,2003,2004],

      g:[
        {id:'kawasaki-en500-gen1',years:[1996,1997,1998,1999,2000,2001,2002,2003,2004]}
      ]
    },

    

  

    {
      s:'kawasaki-kr-1',
      l:'KAWASAKI KR-1',
      y:[1988,1989],

      g:[
        {id:'kawasaki-kr-1-gen1',years:[1988,1989]}
      ]
    },

    {
      s:'kawasaki-kr-1s',
      l:'KAWASAKI KR-1S',
      y:[1990,1991,1992],

      g:[
        {id:'kawasaki-kr-1s-gen1',years:[1990,1991,1992]}
      ]
    },

    {
      s:'kawasaki-kr250',
      l:'KAWASAKI KR250',
      y:[1989,1990,1991,1992,1993],

      g:[
        {id:'kawasaki-kr250-gen1',years:[1989,1990,1991,1992,1993]}
      ]
    },

    {
      s:'kawasaki-z1300',
      l:'KAWASAKI Z1300',
      y:[1979,1980,1981,1982,1983,1984,1985,1986],

      g:[
        {id:'kawasaki-z1300-gen1',years:[1979,1980,1981,1982,1983,1984,1985,1986]}
      ]
    },

    {
      s:'kawasaki-z750-l',
      l:'KAWASAKI Z750 L',
      y:[2004,2005,2006],

      g:[
        {id:'kawasaki-z750-l-gen1',years:[2004,2005,2006]}
      ]
    },

    {
      s:'kawasaki-z750-m',
      l:'KAWASAKI Z750 M',
      y:[2007,2008,2009,2010,2011,2012,2013,2014],

      g:[
        {id:'kawasaki-z750-m-gen1',years:[2007,2008,2009,2010,2011,2012,2013,2014]}
      ]
    },

    {
      s:'kawasaki-z800',
      l:'KAWASAKI Z800',
      y:[2013,2014,2015,2016],

      g:[
        {id:'kawasaki-z800-gen1',years:[2013,2014,2015,2016]}
      ]
    },

    {
      s:'kawasaki-zr-7f',
      l:'KAWASAKI ZR-7F',
      y:[1999,2000,2001,2002,2003,2004],

      g:[
        {id:'kawasaki-zr-7f-gen1',years:[1999,2000,2001,2002,2003,2004]}
      ]
    },

    {
      s:'kawasaki-zr-7s',
      l:'KAWASAKI ZR-7S',
      y:[2001,2002,2003,2004],

      g:[
        {id:'kawasaki-zr-7s-gen1',years:[2001,2002,2003,2004]}
      ]
    },

    {
      s:'kawasaki-zx-10',
      l:'KAWASAKI ZX-10',
      y:[1988,1989,1990,1991],

      g:[
        {id:'kawasaki-zx-10-gen1',years:[1988,1989,1990,1991]}
      ]
    },

    {
      s:'kawasaki-zxr750',
      l:'KAWASAKI ZXR750',
      y:[1991,1992,1993,1994,1995],

      g:[
        {id:'kawasaki-zxr750-gen1',years:[1991,1992,1993,1994,1995]}
      ]
    },

    {
      s:'kawasaki-zx-9r',
      l:'KAWASAKI ZX-9R',
      y:[1994,1995,1996,1997],

      g:[
        {id:'kawasaki-zx-9r-gen1',years:[1994,1995,1996,1997]}
      ]
    },

    {
      s:'kawasaki-er5',
      l:'KAWASAKI ER5',
      y:[2005,2006,2007],

      g:[
        {id:'kawasaki-er5-gen1',years:[2005,2006,2007]}
      ]
    },

    {
      s:'kawasaki-ninja-ex250r',
      l:'KAWASAKI NINJA EX250R',
      y:[2008,2009,2010,2011,2012],

      g:[
        {id:'kawasaki-ninja-ex250r-gen1',years:[2008,2009,2010,2011,2012]}
      ]
    },

    {
      s:'kawasaki-ninja-ex300r',
      l:'KAWASAKI NINJA EX300R',
      y:[2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-ninja-ex300r-gen1',years:[2013,2014,2015,2016,2017]},
        {id:'kawasaki-ninja-ex300r-gen2',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-ex500',
      l:'KAWASAKI EX500',
      y:[1994,1995,1996],

      g:[
        {id:'kawasaki-ex500-gen1',years:[1994,1995,1996]}
      ]
    },

    {
      s:'kawasaki-gpz500',
      l:'KAWASAKI GPZ500',
      y:[1994,1995],

      g:[
        {id:'kawasaki-gpz500-gen1',years:[1994,1995]}
      ]
    },

    {
      s:'kawasaki-ninja-zx-4rr',
      l:'KAWASAKI NINJA ZX-4RR',
      y:[2023,2024,2025,2026],

      g:[
        {id:'kawasaki-ninja-zx-4rr-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-kx85-sw',
      l:'KAWASAKI KX85 SW',
      y:[1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025],

      g:[
        {id:'kawasaki-kx85-sw-gen1',years:[1998,1999,2000,2001]},
        {id:'kawasaki-kx85-sw-gen2',years:[2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013]},
        {id:'kawasaki-kx85-sw-gen3',years:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025]}
      ]
    },

    {
      s:'kawasaki-kx85-lw',
      l:'KAWASAKI KX85 LW',
      y:[1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025],

      g:[
        {id:'kawasaki-kx85-lw-gen1',years:[1998,1999,2000,2001]},
        {id:'kawasaki-kx85-lw-gen2',years:[2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013]},
        {id:'kawasaki-kx85-lw-gen3',years:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025]}
      ]
    },

    {
      s:'kawasaki-kx85-ords',
      l:'KAWASAKI KX85 - K-TECH ORDS',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-kx85-ords-gen1',years:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-ninja-250',
      l:'KAWASAKI NINJA 250',
      y:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-ninja-250-gen1',years:[2008,2009,2010,2011,2012]},
        {id:'kawasaki-ninja-250-gen2',years:[2013,2014,2015,2016,2017]},
        {id:'kawasaki-ninja-250-gen3',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-ninja-300',
      l:'KAWASAKI NINJA 300',
      y:[2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-ninja-300-gen1',years:[2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-ninja-400',
      l:'KAWASAKI NINJA 400',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-ninja-400-gen1',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-ninja-500',
      l:'KAWASAKI NINJA 500',
      y:[2024,2025,2026],

      g:[
        {id:'kawasaki-ninja-500-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-ninja-650',
      l:'KAWASAKI NINJA 650',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-ninja-650-gen1',years:[2017,2018,2019]},
        {id:'kawasaki-ninja-650-gen2',years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-ninja-zx-4r',
      l:'KAWASAKI NINJA ZX-4R',
      y:[2023,2024,2025,2026],

      g:[
        {id:'kawasaki-ninja-zx-4r-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-ninja-zx-6r',
      l:'KAWASAKI NINJA ZX-6R',
      y:[1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-ninja-zx-6r-gen1',years:[1998,1999,2000,2001,2002]},
        {id:'kawasaki-ninja-zx-6r-gen2',years:[2003,2004,2005]},
        {id:'kawasaki-ninja-zx-6r-gen3',years:[2006,2007,2008,2009,2010]},
        {id:'kawasaki-ninja-zx-6r-gen4',years:[2011,2012,2013]},
        {id:'kawasaki-ninja-zx-6r-gen5',years:[2014,2015,2016,2017,2018]},
        {id:'kawasaki-ninja-zx-6r-gen6',years:[2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-ninja-zx-10r',
      l:'KAWASAKI NINJA ZX-10R',
      y:[2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-ninja-zx-10r-gen1',years:[2004,2005]},
        {id:'kawasaki-ninja-zx-10r-gen2',years:[2006,2007]},
        {id:'kawasaki-ninja-zx-10r-gen3',years:[2008,2009,2010]},
        {id:'kawasaki-ninja-zx-10r-gen4',years:[2011,2012,2013,2014,2015]},
        {id:'kawasaki-ninja-zx-10r-gen5',years:[2016,2017,2018,2019,2020]},
        {id:'kawasaki-ninja-zx-10r-gen6',years:[2021,2022,2023,2024,2025]},
        {id:'kawasaki-ninja-zx-10r-gen7',years:[2026]}
      ]
    },

    {
      s:'kawasaki-ninja-zx-10r-SE',
      l:'KAWASAKI NINJA ZX-10R SE',
      y:[2018,2019],

      g:[
        {id:'kawasaki-ninja-zx-10r-SE-gen1',years:[2018,2019]},
      ]
    },

    {
      s:'kawasaki-z650',
      l:'KAWASAKI Z650',
      y:[2017,2018,2019,2020,2021],

      g:[
        {id:'kawasaki-z650-gen1',years:[2017,2018,2019,2020,2021]},
        {id:'kawasaki-z650-gen2',years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-z650rs',
      l:'KAWASAKI Z650 RS',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-z650rs-gen1',years:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]},
      ]
    },

    {
      s:'kawasaki-z900',
      l:'KAWASAKI Z900',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-z900-gen1',years:[2017,2018,2019,2020]},
        {id:'kawasaki-z900-gen2',years:[2020,2021,2022,2023,2024]},
        {id:'kawasaki-z900-gen3',years:[2025,2026]}
      ]
    },

    {
      s:'kawasaki-z900-rs',
      l:'KAWASAKI Z900RS',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-z900-rs-gen1',years:[2018,2019,2020,2021,2022,2023,2024]},
        {id:'kawasaki-z900-rs-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'kawasaki-gpz900r',
      l:'KAWASAKI GPZ900R',
      y:[1984,1985,1986,1987,1988,1989,1990,1991,1992,1993,1994,1995,1996,1997,1998,1999,2000,2001,2002,2003],

      g:[
        {id:'kawasaki-gpz900r-gen1',years:[1984,1985,1986,1987,1988,1989]},
        {id:'kawasaki-gpz900r-gen2',years:[1990,1991,1992,1993]},
        {id:'kawasaki-gpz900r-gen3',years:[1994,1995,1996,1997,1998,1999,2000,2001,2002,2003]}
      ]
    },

    {
      s:'kawasaki-z1000',
      l:'KAWASAKI Z1000',
      y:[2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013],

      g:[
        {id:'kawasaki-z1000-gen1',years:[2003,2004,2005,2006]},
        {id:'kawasaki-z1000-gen2',years:[2007,2008,2009]},
        {id:'kawasaki-z1000-gen3',years:[2010,2011,2012,2013]},
      ]
    },

    {
      s:'kawasaki-versys-650',
      l:'KAWASAKI VERSYS 650',
      y:[2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-versys-650-gen1',years:[2007,2008,2009]},
        {id:'kawasaki-versys-650-gen2',years:[2010,2011,2012,2013,2014]},
        {id:'kawasaki-versys-650-gen3',years:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-versys-1000',
      l:'KAWASAKI VERSYS 1000',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-versys-1000-gen1',years:[2012,2013,2014]},
        {id:'kawasaki-versys-1000-gen2',years:[2015,2016,2017,2018]},
        {id:'kawasaki-versys-1000-gen3',years:[2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-eliminator-400',
      l:'KAWASAKI ELIMINATOR 400',
      y:[2023,2024,2025,2026],

      g:[
        {id:'kawasaki-eliminator-400-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-klx250',
      l:'KAWASAKI KLX250',
      y:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-klx250-gen1',years:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020]},
        {id:'kawasaki-klx250-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'kawasaki-klx230',
      l:'KAWASAKI KLX230',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'kawasaki-klx230-gen1',years:[2020,2021,2022,2023,2024]},
        {id:'kawasaki-klx230-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'kawasaki-kx250',
      l:'KAWASAKI KX250',
      y:[1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008],

      g:[
        {id:'kawasaki-kx250-gen2',years:[1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989]},
        {id:'kawasaki-kx250-gen3',years:[1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]},
        {id:'kawasaki-kx250-gen4',years:[1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008]}
      ]
    },

    {
      s:'kawasaki-kx250f',
      l:'KAWASAKI KX250F',
      y:[2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026,2027],

      g:[
        {id:'kawasaki-kx250f-gen1',years:[2004,2005]},
        {id:'kawasaki-kx250f-gen2',years:[2006,2007,2008]},
        {id:'kawasaki-kx250f-gen3',years:[2009,2010]},
        {id:'kawasaki-kx250f-gen4',years:[2011,2012,2013,2014,2015,2016]},
        {id:'kawasaki-kx250f-gen5',years:[2017,2018,2019,2020]},
        {id:'kawasaki-kx250f-gen6',years:[2021,2022,2023,2024,2025,2026,2027]},
      ]
    },

    {
      s:'kawasaki-kx450',
      l:'KAWASAKI KX450',
      y:[2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,20255,2026],

      g:[
        {id:'kawasaki-kx450-gen1',years:[2005,2006,2007,2008]},
        {id:'kawasaki-kx450-gen2',years:[2009,2010,2011]},
        {id:'kawasaki-kx450-gen3',years:[2012,2013,2014,2015]},
        {id:'kawasaki-kx450-gen4',years:[2016,2017,2018]},
        {id:'kawasaki-kx450-gen5',years:[2019,2020,2021,2022,2023,2024,20255,2026]}
      ]
    },

     {
      s:'kawasaki-kx450f',
      l:'KAWASAKI KX450F',
      y:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026,2027],

      g:[
        {id:'kawasaki-kx450f-gen1',years:[2006,2007,2008]},
        {id:'kawasaki-kx450f-gen2',years:[2009,2010,2011,2012,2013,2014]},
        {id:'kawasaki-kx450f-gen3',years:[2015,2016,2017,2018]},
        {id:'kawasaki-kx450f-gen4',years:[2019,2020,2021,2022,2023]},
        {id:'kawasaki-kx450f-gen4',years:[2024,2025,2026,2027]}
      ]
    },
  ],

  'KOVE': [

    {
      s:'kove-250-rally',
      l:'KOVE 250 RALLY',
      y:[2023,2024,2025,2026],

      g:[
        {id:'kove-250-rally-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'kove-450-rally',
      l:'KOVE 450 RALLY',
      y:[2023,2024,2025,2026],

      g:[
        {id:'kove-450-rally-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'kove-450-rally-ex',
      l:'KOVE 450 RALLY EX',
      y:[2023,2024,2025,2026],

      g:[
        {id:'kove-450-rally-ex-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'kove-450-enduro',
      l:'KOVE 450 ENDURO',
      y:[2023,2024,2025,2026],

      g:[
        {id:'kove-450-enduro-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'kove-510x',
      l:'KOVE 510X',
      y:[2023,2024,2025,2026],

      g:[
        {id:'kove-510x-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'kove-800x',
      l:'KOVE 800X',
      y:[2024,2025,2026],

      g:[
        {id:'kove-800x-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'kove-800x-pro',
      l:'KOVE 800X PRO',
      y:[2024,2025,2026],

      g:[
        {id:'kove-800x-pro-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'kove-800x-adventure',
      l:'KOVE 800X ADVENTURE',
      y:[2024,2025,2026],

      g:[
        {id:'kove-800x-adventure-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'kove-800x-rally',
      l:'KOVE 800X RALLY',
      y:[2024,2025,2026],

      g:[
        {id:'kove-800x-rally-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'kove-450r',
      l:'KOVE 450R',
      y:[2024,2025,2026],

      g:[
        {id:'kove-450r-gen1',years:[2024,2025,2026]}
      ]
    },
  ],

  'KTM': [

    {
      s:'ktm-50sx',
      l:'KTM 50SX',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-50sx-gen1',years:[2012,2013,2014,2015,2016]},
        {id:'ktm-50sx-gen2',years:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktm-65sx',
      l:'KTM 65SX',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-65sx-gen1',years:[2012,2013,2014,2015,2016]},
        {id:'ktm-65sx-gen2',years:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktm-50sx-mini',
      l:'KTM 50SX MINI',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-50sx-mini-gen1',years:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktm-sx-e-5-electric',
      l:'KTM SX-E 5 ELECTRIC',
      y:[2020,2021,2022,2023,2024,2025],

      g:[
        {id:'ktm-sx-e-5-electric-gen1',years:[2020,2021,2022,2023,2024,2025]}
      ]
    },

    {
      s:'ktm-sx-e5',
      l:'KTM SX-E5',
      y:[2026],

      g:[
        {id:'ktm-sx-e5-gen1',years:[2026]}
      ]
    },

    {
      s:'ktm-125-duke',
      l:'KTM 125 DUKE',
      y:[2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-125-duke-gen1',years:[2011,2012,2013,2014,2015,2016,2017]},
        {id:'ktm-125-duke-gen2',years:[2017,2018,2019,2020,2021,2022,2023]},
        {id:'ktm-125-duke-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'ktm-200-duke',
      l:'KTM 200 DUKE',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-200-duke-gen1',years:[2012,2013,2014,2015,2016,2017,2018,2019,2020]},
        {id:'ktm-200-duke-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktm-250-duke',
      l:'KTM 250 DUKE',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-250-duke-gen1',years:[2017,2018,2019,2020,2021,2022,2023]},
        {id:'ktm-250-duke-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'ktm-390-duke',
      l:'KTM 390 DUKE',
      y:[2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-390-duke-gen1',years:[2013,2014,2015,2016,2017]},
        {id:'ktm-390-duke-gen2',years:[2017,2018,2019,2020,2021,2022,2023]},
        {id:'ktm-390-duke-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'ktm-690-duke',
      l:'KTM 690 DUKE',
      y:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017],

      g:[
        {id:'ktm-690-duke-gen1',years:[2008,2009,2010,2011,2012,2013]},
        {id:'ktm-690-duke-gen2',years:[2014,2015,2016,2017]}
      ]
    },

    {
      s:'ktm-790-duke',
      l:'KTM 790 DUKE',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-790-duke-gen1',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktm-890-duke-r',
      l:'KTM 890 DUKE R',
      y:[2020,2021,2022,2023,2024],

      g:[
        {id:'ktm-890-duke-r-gen1',years:[2020,2021,2022,2023,2024]}
      ]
    },

    {
      s:'ktm-990-duke',
      l:'KTM 990 DUKE',
      y:[2024,2025,2026],

      g:[
        {id:'ktm-990-duke-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'ktm-1290-super-duke-r',
      l:'KTM 1290 SUPER DUKE R',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024],

      g:[
        {id:'ktm-1290-super-duke-r-gen1',years:[2014,2015,2016,2017,2018,2019]},
        {id:'ktm-1290-super-duke-r-gen2',years:[2020,2021,2022,2023,2024]}
      ]
    },

    {
      s:'ktm-1390-super-duke-r',
      l:'KTM 1390 SUPER DUKE R',
      y:[2024,2025,2026],

      g:[
        {id:'ktm-1390-super-duke-r-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'ktm-rc-125',
      l:'KTM RC 125',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-rc-125-gen1',years:[2014,2015,2016,2017,2018,2019,2020]},
        {id:'ktm-rc-125-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktm-rc-200',
      l:'KTM RC 200',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-rc-200-gen1',years:[2014,2015,2016,2017,2018,2019,2020]},
        {id:'ktm-rc-200-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktm-rc-390',
      l:'KTM RC 390',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-rc-390-gen1',years:[2014,2015,2016,2017,2018,2019,2020,2021]},
        {id:'ktm-rc-390-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktm-250-adventure',
      l:'KTM 250 ADVENTURE',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-250-adventure-gen1',years:[2021,2022,2023,2024]},
        {id:'ktm-250-adventure-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'ktm-390-adventure',
      l:'KTM 390 ADVENTURE',
      y:[2020,2021,2022,2023,2024],

      g:[
        {id:'ktm-390-adventure-gen1',years:[2020,2021,2022]},
        {id:'ktm-390-adventure-gen2',years:[2023,2024]},
      ]
    },

    {
      s:'ktm-390-adventure-r',
      l:'KTM 390 ADVENTURE R',
      y:[2025,2026],

      g:[
        {id:'ktm-390-adventure-r-gen1',years:[2025,2026]}
      ]
    },

      {
      s:'ktm-390-adventure-x',
      l:'KTM 390 ADVENTURE X',
      y:[2025],

      g:[
        {id:'ktm-390-adventure-x-gen1',years:[2025]}
      ]
    },

    {
      s:'ktm-690-enduro-r',
      l:'KTM 690 ENDURO R',
      y:[2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-690-enduro-r-gen1',years:[2009,2010,2011]},
        {id:'ktm-690-enduro-r-gen2',years:[2012,2013,2014,2015,2016,2017,2018]},
        {id:'ktm-690-enduro-r-gen3',years:[2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

       {
      s:'ktm-690-smc',
      l:'KTM 690 SMC',
      y:[2009,2010,2011],

      g:[
        {id:'ktm-690-smc-gen1',years:[2009,2010,2011]}
      ]
    },

    {
      s:'ktm-690-smc-r',
      l:'KTM 690 SMC R',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-690-smc-r-gen1',years:[2012,2013,2014,2015,2016,2017,2018]},
        {id:'ktm-690-smc-r-gen2',years:[2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktm-790-adventure',
      l:'KTM 790 ADVENTURE',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-790-adventure-gen1',years:[2019,2020,2021,2022,2023]},
        {id:'ktm-790-adventure-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'ktm-790-adventure-r',
      l:'KTM 790 ADVENTURE R',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-790-adventure-r-gen1',years:[2019,2020,2021,2022,2023]},
        {id:'ktm-790-adventure-r-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'ktm-890-adventure',
      l:'KTM 890 ADVENTURE',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-890-adventure-gen1',years:[2021,2022]},
        {id:'ktm-890-adventure-gen2',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktm-890-adventure-r',
      l:'KTM 890 ADVENTURE R',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-890-adventure-r-gen1',years:[2021,2022,2023,2024,2025,2026]},
      ]
    },

    {
      s:'ktm-1290-super-adventure-s',
      l:'KTM 1290 SUPER ADVENTURE S',
      y:[2017,2018,2019,2020,2021],

      g:[
        {id:'ktm-1290-super-adventure-s-gen1',years:[2015,2016,2017,2018,2019,2020]},
        {id:'ktm-1290-super-adventure-s-gen2',years:[2021]}
      ]
    },

    {
      s:'ktm-1290-super-adventure-r',
      l:'KTM 1290 SUPER ADVENTURE R',
      y:[2017,2018,2019,2020,2021,2022,2023,2024],

      g:[
        {id:'ktm-1290-super-adventure-r-gen1',years:[2017,2018,2019,2020]},
        {id:'ktm-1290-super-adventure-r-gen2',years:[2021,2022,2023,2024]}
      ]
    },

    {
      s:'ktm-450-exc-f',
      l:'KTM 450 EXC-F',
      y:[2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-450-exc-f-gen1',years:[2003,2004,2005,2006,2007]},
        {id:'ktm-450-exc-f-gen2',years:[2008,2009,2010,2011,2012,2013,2014,2015,2016]},
        {id:'ktm-450-exc-f-gen3',years:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'ktm-500-exc-f',
      l:'KTM 500 EXC-F',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'ktm-500-exc-f-gen1',years:[2012,2013,2014,2015,2016]},
        {id:'ktm-500-exc-f-gen2',years:[2017,2018,2019]},
        {id:'ktm-500-exc-f-gen3',years:[2020,2021,2022,2023]},
        {id:'ktm-500-exc-f-gen4',years:[2024,2025,2026]},
      ]
    },
  ],

  'MARZOCCHI': [

    {
      s:'marzocchi-mx-series',
      l:'MARZOCCHI MX SERIES',

      g:[
        {id:'marzocchi-mx-series-gen1',years:[]}
      ]
    },

    {
      s:'marzocchi-320-series',
      l:'MARZOCCHI 320 SERIES',

      g:[
        {id:'marzocchi-320-series-gen1',years:[]}
      ]
    },

    {
      s:'marzocchi-380-series',
      l:'MARZOCCHI 380 SERIES',

      g:[
        {id:'marzocchi-380-series-gen1',years:[]}
      ]
    },

    {
      s:'marzocchi-45-series',
      l:'MARZOCCHI 45 SERIES',

      g:[
        {id:'marzocchi-45-series-gen1',years:[]}
      ]
    },

    {
      s:'marzocchi-50-series',
      l:'MARZOCCHI 50 SERIES',

      g:[
        {id:'marzocchi-50-series-gen1',years:[]}
      ]
    },

    {
      s:'marzocchi-mono-shock',
      l:'MARZOCCHI MONOSHOCK',

      g:[
        {id:'marzocchi-mono-shock-gen1',years:[]}
      ]
    },

    {
      s:'marzocchi-twin-shock',
      l:'MARZOCCHI TWIN SHOCK',

      g:[
        {id:'marzocchi-twin-shock-gen1',years:[]}
      ]
    },
  ],

  'MOTO GUZZI': [

    {
      s:'moto-guzzi-v7',
      l:'MOTO GUZZI V7',
      y:[2008,2009,2010,2011,2012,2013],
      g:[{id:'moto-guzzi-v7-gen1',years:[2008,2009,2010,2011,2012,2013]}]
    },

    {
      s:'moto-guzzi-v7-ii',
      l:'MOTO GUZZI V7 II',
      y:[2014,2015,2016],
      g:[{id:'moto-guzzi-v7-ii-gen1',years:[2014,2015,2016]}]
    },

    {
      s:'moto-guzzi-v7-iii',
      l:'MOTO GUZZI V7 III',
      y:[2017,2018,2019,2020],
      g:[{id:'moto-guzzi-v7-iii-gen1',years:[2017,2018,2019,2020]}]
    },

    {
      s:'moto-guzzi-v7-iiii',
      l:'MOTO GUZZI V7 IIII (V7 850)',
      y:[2021,2022,2023,2024,2025,2026,2027],
      g:[{id:'moto-guzzi-v7-iiii-gen1',years:[2021,2022,2023,2024,2025,2026,2027]}]
    },

    {
      s:'moto-guzzi-griso',
      l:'MOTO GUZZI GRISO',
      y:[2007,2008,2009,2010,2011,2012,2013,2014,2015],
      g:[{id:'moto-guzzi-griso-gen1',years:[2007,2008,2009,2010,2011,2012,2013,2014,2015]}]
    },
  ],


  'MV AGUSTA': [

    {
      s:'mv-agusta-brutale-675',
      l:'MV AGUSTA BRUTALE 675',
      y:[2012,2013,2014,2015,2016],

      g:[
        {id:'mv-agusta-brutale-675-gen1',years:[2012,2013,2014,2015,2016]}
      ]
    },

    {
      s:'mv-agusta-brutale-800-rosso',
      l:'MV AGUSTA BRUTALE 800 ROSSO',
      y:[2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'mv-agusta-brutale-800-rosso-gen1',years:[2013,2014,2015,2016]},
        {id:'mv-agusta-brutale-800-rosso-gen2',years:[2017,2018,2019,2020]},
        {id:'mv-agusta-brutale-800-rosso-gen3',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'mv-agusta-brutale-800-rr',
      l:'MV AGUSTA BRUTALE 800 RR',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'mv-agusta-brutale-800-rr-gen1',years:[2015,2016]},
        {id:'mv-agusta-brutale-800-rr-gen2',years:[2017,2018,2019,2020]},
        {id:'mv-agusta-brutale-800-rr-gen3',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'mv-agusta-brutale-1000-rr',
      l:'MV AGUSTA BRUTALE 1000 RR',
      y:[2010,2011,2012,2013],

      g:[
        {id:'mv-agusta-brutale-1000-rr-gen1',years:[2010,2011,2012]},
        {id:'mv-agusta-brutale-1000-rr-gen2',years:[2013]}
      ]
    },

    {
      s:'mv-agusta-dragster-800',
      l:'MV AGUSTA DRAGSTER 800',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'mv-agusta-dragster-800-gen1',years:[2014,2015,2016]},
        {id:'mv-agusta-dragster-800-gen2',years:[2017,2018,2019,2020]},
        {id:'mv-agusta-dragster-800-gen3',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'mv-agusta-dragster-800-rr',
      l:'MV AGUSTA DRAGSTER 800 RR',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'mv-agusta-dragster-800-rr-gen1',years:[2015,2016]},
        {id:'mv-agusta-dragster-800-rr-gen2',years:[2017,2018,2019,2020]},
        {id:'mv-agusta-dragster-800-rr-gen3',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'mv-agusta-f3-675',
      l:'MV AGUSTA F3 675',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020],

      g:[
        {id:'mv-agusta-f3-675-gen1',years:[2012,2013,2014,2015]},
        {id:'mv-agusta-f3-675-gen2',years:[2016,2017,2018,2019,2020]}
      ]
    },

    {
      s:'mv-agusta-f3-800',
      l:'MV AGUSTA F3 800',
      y:[2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'mv-agusta-f3-800-gen1',years:[2013,2014,2015,2016]},
        {id:'mv-agusta-f3-800-gen2',years:[2017,2018,2019,2020]},
        {id:'mv-agusta-f3-800-gen3',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'mv-agusta-f4-750',
      l:'MV AGUSTA F4 750',
      y:[1999,2000,2001,2002,2003,2004,2005,2006],

      g:[
        {id:'mv-agusta-f4-750-gen1',years:[1999,2000,2001,2002,2003,2004,2005,2006]}
      ]
    },

    {
      s:'mv-agusta-f3-800',
      l:'MV AGUSTA F3 800',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'mv-agusta-f3-800-gen1',years:[2012,2013,2014,2015,2016,2017,2018,2019,2020]},
        {id:'mv-agusta-f3-800-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'mv-agusta-f4-1000',
      l:'MV AGUSTA F4 1000',
      y:[2009,2010,2011,2012],

      g:[
        {id:'mv-agusta-f4-1000-gen1',years:[2009,2010,2011,2012]},
      ]
    },

    {
      s:'mv-agusta-turismo-veloce-800',
      l:'MV AGUSTA TURISMO VELOCE 800',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'mv-agusta-turismo-veloce-800-gen1',years:[2015,2016,2017,2018,2019,2020]},
        {id:'mv-agusta-turismo-veloce-800-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'mv-agusta-rivale-800',
      l:'MV AGUSTA RIVALE 800',
      y:[2014,2015,2016,2017,2018,2019],

      g:[
        {id:'mv-agusta-rivale-800-gen1',years:[2014,2015,2016,2017,2018,2019]}
      ]
    },

    {
      s:'mv-agusta-superveloce-800',
      l:'MV AGUSTA SUPERVELOCE 800',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'mv-agusta-superveloce-800-gen1',years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'mv-agusta-rush-1000',
      l:'MV AGUSTA RUSH 1000',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'mv-agusta-rush-1000-gen1',years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'mv-agusta-enduro-veloce',
      l:'MV AGUSTA ENDURO VELOCE',
      y:[2024,2025,2026],

      g:[
        {id:'mv-agusta-enduro-veloce-gen1',years:[2024,2025,2026]}
      ]
    },
  ],

  'OHLINS': [

    {
      s:'ohlins-ttx',
      l:'ÖHLINS TTX',

      g:[
        {id:'ohlins-ttx-gen1',years:[]},
        {id:'ohlins-ttx-gen2',years:[]}
      ]
    },

    {
      s:'ohlins-ttx-gp',
      l:'ÖHLINS TTX GP',

      g:[
        {id:'ohlins-ttx-gp-gen1',years:[]}
      ]
    },

    {
      s:'ohlins-ttx-rt',
      l:'ÖHLINS TTX RT',

      g:[
        {id:'ohlins-ttx-rt-gen1',years:[]}
      ]
    },

    {
      s:'ohlins-ttx-air',
      l:'ÖHLINS TTX AIR',

      g:[
        {id:'ohlins-ttx-air-gen1',years:[]}
      ]
    },

    {
      s:'ohlins-stx',
      l:'ÖHLINS STX',

      g:[
        {id:'ohlins-stx-gen1',years:[]},
        {id:'ohlins-stx-gen2',years:[]}
      ]
    },

    {
      s:'ohlins-stx-46',
      l:'ÖHLINS STX 46',

      g:[
        {id:'ohlins-stx-46-gen1',years:[]}
      ]
    },

    {
      s:'ohlins-stx-36',
      l:'ÖHLINS STX 36',

      g:[
        {id:'ohlins-stx-36-gen1',years:[]}
      ]
    },

    {
      s:'ohlins-s46',
      l:'ÖHLINS S46',

      g:[
        {id:'ohlins-s46-gen1',years:[]}
      ]
    },

    {
      s:'ohlins-t36',
      l:'ÖHLINS T36',

      g:[
        {id:'ohlins-t36-gen1',years:[]}
      ]
    },

    {
      s:'ohlins-nix',
      l:'ÖHLINS NIX',

      g:[
        {id:'ohlins-nix-gen1',years:[]}
      ]
    },

    {
      s:'ohlins-fsk',
      l:'ÖHLINS FSK',

      g:[
        {id:'ohlins-fsk-gen1',years:[]}
      ]
    },

    {
      s:'ohlins-fgr',
      l:'ÖHLINS FGR',

      g:[
        {id:'ohlins-fgr-gen1',years:[]}
      ]
    },
  ],

  'ROYAL ENFIELD': [

    {
      s:'royal-enfield-himalayan-411',
      l:'ROYAL ENFIELD HIMALAYAN 411',
      y:[2016,2017,2018,2019,2020,2021,2022,2023],

      g:[
        {id:'royal-enfield-himalayan-411-gen1',years:[2016,2017,2018,2019,2020,2021]},
        {id:'royal-enfield-himalayan-411-gen2',years:[2022,2023]}
      ]
    },

    {
      s:'royal-enfield-himalayan-450',
      l:'ROYAL ENFIELD HIMALAYAN 450',
      y:[2024,2025,2026],

      g:[
        {id:'royal-enfield-himalayan-450-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'royal-enfield-scram-411',
      l:'ROYAL ENFIELD SCRAM 411',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'royal-enfield-scram-411-gen1',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'royal-enfield-scram-450',
      l:'ROYAL ENFIELD SCRAM 450',
      y:[2025,2026],

      g:[
        {id:'royal-enfield-scram-450-gen1',years:[2025,2026]}
      ]
    },

    {
      s:'royal-enfield-classic-350',
      l:'ROYAL ENFIELD CLASSIC 350',
      y:[2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'royal-enfield-classic-350-gen1',years:[2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020]},
        {id:'royal-enfield-classic-350-gen2',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'royal-enfield-meteor-350',
      l:'ROYAL ENFIELD METEOR 350',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'royal-enfield-meteor-350-gen1',years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'royal-enfield-bullet-350',
      l:'ROYAL ENFIELD BULLET 350',
      y:[2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'royal-enfield-bullet-350-gen1',years:[2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023]},
        {id:'royal-enfield-bullet-350-gen2',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'royal-enfield-continental-gt-650',
      l:'ROYAL ENFIELD CONTINENTAL GT 650',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'royal-enfield-continental-gt-650-gen1',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'royal-enfield-interceptor-650',
      l:'ROYAL ENFIELD INTERCEPTOR 650',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'royal-enfield-interceptor-650-gen1',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'royal-enfield-super-meteor-650',
      l:'ROYAL ENFIELD SUPER METEOR 650',
      y:[2023,2024,2025,2026],

      g:[
        {id:'royal-enfield-super-meteor-650-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'royal-enfield-guerrilla-450',
      l:'ROYAL ENFIELD GUERRILLA 450',
      y:[2024,2025,2026],

      g:[
        {id:'royal-enfield-guerrilla-450-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'royal-enfield-hunter-350',
      l:'ROYAL ENFIELD HUNTER 350',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'royal-enfield-hunter-350-gen1',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'royal-enfield-shotgun-650',
      l:'ROYAL ENFIELD SHOTGUN 650',
      y:[2024,2025,2026],

      g:[
        {id:'royal-enfield-shotgun-650-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'royal-enfield-classic-500',
      l:'ROYAL ENFIELD CLASSIC 500',
      y:[2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020],

      g:[
        {id:'royal-enfield-classic-500-gen1',years:[2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020]}
      ]
    },

    {
      s:'royal-enfield-bullet-500',
      l:'ROYAL ENFIELD BULLET 500',
      y:[2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020],

      g:[
        {id:'royal-enfield-bullet-500-gen1',years:[2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020]}
      ]
    },
  ],

  'SHERCO': [

    {
      s:'sherco-se-125',
      l:'SHERCO SE 125',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-se-125-gen1',years:[2012,2013,2014,2015,2016,2017,2018,2019]},
        {id:'sherco-se-125-gen2',years:[2020,2021,2022,2023]},
        {id:'sherco-se-125-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-se-250',
      l:'SHERCO SE 250',
      y:[2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-se-250-gen1',years:[2005,2006,2007,2008,2009,2010,2011,2012]},
        {id:'sherco-se-250-gen2',years:[2013,2014,2015,2016,2017,2018,2019]},
        {id:'sherco-se-250-gen3',years:[2020,2021,2022,2023]},
        {id:'sherco-se-250-gen4',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-se-300',
      l:'SHERCO SE 300',
      y:[2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-se-300-gen1',years:[2005,2006,2007,2008,2009,2010,2011,2012]},
        {id:'sherco-se-300-gen2',years:[2013,2014,2015,2016,2017,2018,2019]},
        {id:'sherco-se-300-gen3',years:[2020,2021,2022,2023]},
        {id:'sherco-se-300-gen4',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-sef-250',
      l:'SHERCO SEF 250',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-sef-250-gen1',years:[2012,2013,2014,2015,2016,2017,2018,2019]},
        {id:'sherco-sef-250-gen2',years:[2020,2021,2022,2023]},
        {id:'sherco-sef-250-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-sef-300',
      l:'SHERCO SEF 300',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-sef-300-gen1',years:[2012,2013,2014,2015,2016,2017,2018,2019]},
        {id:'sherco-sef-300-gen2',years:[2020,2021,2022,2023]},
        {id:'sherco-sef-300-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-sef-450',
      l:'SHERCO SEF 450',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-sef-450-gen1',years:[2012,2013,2014,2015,2016,2017,2018,2019]},
        {id:'sherco-sef-450-gen2',years:[2020,2021,2022,2023]},
        {id:'sherco-sef-450-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-sef-500',
      l:'SHERCO SEF 500',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-sef-500-gen1',years:[2012,2013,2014,2015,2016,2017,2018,2019]},
        {id:'sherco-sef-500-gen2',years:[2020,2021,2022,2023]},
        {id:'sherco-sef-500-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-se-250-factory',
      l:'SHERCO SE 250 FACTORY',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-se-250-factory-gen1',years:[2017,2018,2019,2020,2021,2022,2023]},
        {id:'sherco-se-250-factory-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-se-300-factory',
      l:'SHERCO SE 300 FACTORY',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-se-300-factory-gen1',years:[2017,2018,2019,2020,2021,2022,2023]},
        {id:'sherco-se-300-factory-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-sef-250-factory',
      l:'SHERCO SEF 250 FACTORY',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-sef-250-factory-gen1',years:[2017,2018,2019,2020,2021,2022,2023]},
        {id:'sherco-sef-250-factory-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-sef-300-factory',
      l:'SHERCO SEF 300 FACTORY',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-sef-300-factory-gen1',years:[2017,2018,2019,2020,2021,2022,2023]},
        {id:'sherco-sef-300-factory-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-sef-450-factory',
      l:'SHERCO SEF 450 FACTORY',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-sef-450-factory-gen1',years:[2017,2018,2019,2020,2021,2022,2023]},
        {id:'sherco-sef-450-factory-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-sef-500-factory',
      l:'SHERCO SEF 500 FACTORY',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-sef-500-factory-gen1',years:[2017,2018,2019,2020,2021,2022,2023]},
        {id:'sherco-sef-500-factory-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sherco-se-125-factory',
      l:'SHERCO SE 125 FACTORY',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sherco-se-125-factory-gen1',years:[2017,2018,2019,2020,2021,2022,2023]},
        {id:'sherco-se-125-factory-gen2',years:[2024,2025,2026]}
      ]
    },
  ],

  'SURRON': [

    {
      s:'sur-ron-light-bee-x',
      l:'SUR-RON LIGHT BEE X',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sur-ron-light-bee-x-gen1',years:[2018,2019,2020,2021,2022]},
        {id:'sur-ron-light-bee-x-gen2',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'sur-ron-light-bee-l1e',
      l:'SUR-RON LIGHT BEE L1E',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sur-ron-light-bee-l1e-gen1',years:[2018,2019,2020,2021,2022]},
        {id:'sur-ron-light-bee-l1e-gen2',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'sur-ron-ultra-bee',
      l:'SUR-RON ULTRA BEE',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'sur-ron-ultra-bee-gen1',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'sur-ron-ultra-bee-r',
      l:'SUR-RON ULTRA BEE R',
      y:[2024,2025,2026],

      g:[
        {id:'sur-ron-ultra-bee-r-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'sur-ron-storm-bee',
      l:'SUR-RON STORM BEE',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sur-ron-storm-bee-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'sur-ron-light-bee-s',
      l:'SUR-RON LIGHT BEE S',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'sur-ron-light-bee-s-gen1',years:[2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'sur-ron-hyper-bee',
      l:'SUR-RON HYPER BEE',
      y:[2025,2026],

      g:[
        {id:'sur-ron-hyper-bee-gen1',years:[2025,2026]}
      ]
    },
  ],

  'SUZUKI': [

    {
      s:'suzuki-dr-z400',
      l:'SUZUKI DR-Z400',
      y:[2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024],

      g:[
        {id:'suzuki-dr-z400-gen1',years:[2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024]},
      ]
    },

    {
      s:'suzuki-dr650se',
      l:'SUZUKI DR650SE',
      y:[1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017],

      g:[
        {id:'suzuki-dr650se-gen1',years:[1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017]}
      ]
    },

    {
      s:'suzuki-gsf600-bandit',
      l:'SUZUKI GSF600 BANDIT',
      y:[2000,2001,2002,2003,2004],

      g:[
        {id:'suzuki-gsf600-bandit-gen2',years:[2000,2001,2002,2003,2004]}
      ]
    },

    {
      s:'suzuki-gsf650s-bandit',
      l:'SUZUKI GSF650S BANDIT',
      y:[2005,2006,2007,2008,2009,2010,2011,2012,2013],

      g:[
        {id:'suzuki-gsf650s-bandit-gen1',years:[2005,2006,2007,2008,2009,2010,2011,2012,2013]}
      ]
    },


    {
      s:'suzuki-gsf400-bandit',
      l:'SUZUKI GSF400 BANDIT',
      y:[1991,1992,1993,1994],

      g:[
        {id:'suzuki-gsf400-bandit-gen1',years:[1991,1992,1993,1994]}
      ]
    },

    {
      s:'suzuki-gs500',
      l:'SUZUKI GS500',
      y:[2006,2007],

      g:[
        {id:'suzuki-gs500-gen1',years:[2006,2007]}
      ]
    },

    {
      s:'suzuki-gsf600-bandit',
      l:'SUZUKI GSF600 BANDIT',
      y:[1995,1996,1997,1998,1999],

      g:[
        {id:'suzuki-gsf600-bandit-gen1',years:[1995,1996,1997,1998,1999]}
      ]
    },

    {
      s:'suzuki-gsf650n-bandit',
      l:'SUZUKI GSF650N BANDIT',
      y:[2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016],

      g:[
        {id:'suzuki-gsf650n-bandit-gen1',years:[2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016]}
      ]
    },

    {
      s:'suzuki-gsx600f-katana',
      l:'SUZUKI GSX600F KATANA',
      y:[1998,1999,2000,2001,2002,2003,2004,2005,2006,2007],

      g:[
        {id:'suzuki-gsx600f-katana-gen1',years:[1998,1999,2000,2001,2002,2003,2004,2005,2006,2007]}
      ]
    },

    {
      s:'suzuki-gsx-r1100',
      l:'SUZUKI GSX-R1100',
      y:[1986,1987,1988,1989,1990,1991,1992,1993,1994],

      g:[
        {id:'suzuki-gsx-r1100-gen1',years:[1986,1987,1988,1989,1990,1991,1992]},
        {id:'suzuki-gsx-r1100-gen2',years:[1993,1994]}
      ]
    },

    {
      s:'suzuki-sv650',
      l:'SUZUKI SV650',
      y:[1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022],

      g:[
        {id:'suzuki-sv650-gen1',years:[1998,1999,2000,2001,2002]},
        {id:'suzuki-sv650-gen2',years:[2003,2004,2005,2006,2007,2008]},
        {id:'suzuki-sv650-gen3',years:[2009,2010,2011,2012,2013,2014,2015]},
        {id:'suzuki-sv650-gen4',years:[2016,2017,2018,2019,2020,2021,2022]}
      ]
    },
    
     {
      s:'suzuki-sv650a',
      l:'SUZUKI SV650A',
      y:[2017,2018,2019,2020,2021,2022],

      g:[
        {id:'suzuki-sv650a-gen1',years:[2017,2018,2019,2020,2021,2022]},
      ]
    },

    {
      s:'suzuki-sv650x',
      l:'SUZUKI SV650X',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'suzuki-sv650x-gen1',years:[2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },


    {
      s:'suzuki-gsx1000-sv-katana',
      l:'SUZUKI GSX1000 SV KATANA',
      y:[1982,1983],

      g:[
        {id:'suzuki-gsx1000-sv-katana-gen1',years:[1982,1983]}
      ]
    },

    {
      s:'suzuki-gsx-r600',
      l:'SUZUKI GSX-R600',
      y:[1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021],

      g:[
        {id:'suzuki-gsx-r600-gen1',years:[1997,1998,1999,2000]},
        {id:'suzuki-gsx-r600-gen2',years:[2001,2002,2003]},
        {id:'suzuki-gsx-r600-gen3',years:[2004,2005]},
        {id:'suzuki-gsx-r600-gen4',years:[2006,2007,2008,2009,2010]},
        {id:'suzuki-gsx-r600-gen5',years:[2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'suzuki-gsx-r750',
      l:'SUZUKI GSX-R750',
      y:[1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'suzuki-gsx-r750-gen1',years:[1985,1986,1987,1988,1989]},
        {id:'suzuki-gsx-r750-gen2',years:[1990,1991]},
        {id:'suzuki-gsx-r750-gen3',years:[1992,1993,1994,1995]},
        {id:'suzuki-gsx-r750-gen4',years:[1996,1997,1998,1999]},
        {id:'suzuki-gsx-r750-gen5',years:[2000,2001,2002,2003]},
        {id:'suzuki-gsx-r750-gen6',years:[2004,2005,2006,2007,2008,2009,2010]},
        {id:'suzuki-gsx-r750-gen7',years:[2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]},
      ]
    },

    {
      s:'suzuki-gsx-r1000',
      l:'SUZUKI GSX-R1000',
      y:[2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021],

      g:[
        {id:'suzuki-gsx-r1000-gen1',years:[2001,2002]},
        {id:'suzuki-gsx-r1000-gen2',years:[2003,2004]},
        {id:'suzuki-gsx-r1000-gen3',years:[2005,2006]},
        {id:'suzuki-gsx-r1000-gen4',years:[2007,2008]},
        {id:'suzuki-gsx-r1000-gen5',years:[2009,2010,2011]},
        {id:'suzuki-gsx-r1000-gen6',years:[2012,2013,2014,2015,2016]},
        {id:'suzuki-gsx-r1000-gen7',years:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]},
      ]
    },

    {
      s:'suzuki-hayabusa',
      l:'SUZUKI HAYABUSA',
      y:[1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'suzuki-hayabusa-gen1',years:[1999,2000,2001,2002,2003,2004,2005,2006,2007]},
        {id:'suzuki-hayabusa-gen2',years:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020]},
        {id:'suzuki-hayabusa-gen3',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'suzuki-gsx-s1000',
      l:'SUZUKI GSX-S1000',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'suzuki-gsx-s1000-gen1',years:[2015,2016,2017,2018,2019,2020,2021]},
        {id:'suzuki-gsx-s1000-gen2',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'suzuki-gsx-s750',
      l:'SUZUKI GSX-S750',
      y:[2015,2016,2017,2018,2019,2020,2021],

      g:[
        {id:'suzuki-gsx-s750-gen1',years:[2015,2016]},
        {id:'suzuki-gsx-s750-gen2',years:[2017,2018,2019,2020,2021]}
      ]
    },

    {
      s:'suzuki-gsx-8s',
      l:'SUZUKI GSX-8S',
      y:[2023,2024,2025,2026],

      g:[
        {id:'suzuki-gsx-8s-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'suzuki-gsx-8r',
      l:'SUZUKI GSX-8R',
      y:[2024,2025,2026],

      g:[
        {id:'suzuki-gsx-8r-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'suzuki-v-strom-650',
      l:'SUZUKI V-STROM 650',
      y:[2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023],

      g:[
        {id:'suzuki-v-strom-650-gen1',years:[2004,2005,2006,2007,2008,2009,2010,2011]},
        {id:'suzuki-v-strom-650-gen2',years:[2012,2013,2014,2015,2016]},
        {id:'suzuki-v-strom-650-gen3',years:[2017,2018,2019,2020,2021,2022,2023]}
      ]
    },

    {
      s:'suzuki-v-strom-800',
      l:'SUZUKI V-STROM 800',
      y:[2023,2024,2025,2026],

      g:[
        {id:'suzuki-v-strom-800-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'suzuki-v-strom-800de',
      l:'SUZUKI V-STROM 800DE',
      y:[2023,2024,2025,2026],

      g:[
        {id:'suzuki-v-strom-800de-gen1',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'suzuki-v-strom-1050',
      l:'SUZUKI V-STROM 1050',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'suzuki-v-strom-1050-gen1',years:[2020,2021,2022]},
        {id:'suzuki-v-strom-1050-gen2',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'suzuki-v-strom-1000',
      l:'SUZUKI V-STROM 1000',
      y:[2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019],

      g:[
        {id:'suzuki-v-strom-1000-gen1',years:[2002,2003,2004,2005,2006,2007,2008,2009]},
        {id:'suzuki-v-strom-1000-gen2',years:[2014,2015,2016,2017,2018,2019]}
      ]
    },

    {
      s:'suzuki-gsx250r',
      l:'SUZUKI GSX250R',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'suzuki-gsx250r-gen1',years:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'suzuki-burgman-400',
      l:'SUZUKI BURGMAN 400',
      y:[1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'suzuki-burgman-400-gen1',years:[1999,2000,2001,2002,2003,2004,2005,2006]},
        {id:'suzuki-burgman-400-gen2',years:[2007,2008,2009,2010,2011,2012,2013]},
        {id:'suzuki-burgman-400-gen3',years:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },
  ],

  'TRIUMPH': [

    {
      s:'triumph-street-scrambler',
      l:'TRIUMPH STREET SCRAMBLER',
      y:[2017],

      g:[
        {id:'triumph-street-scrambler-gen2',years:[2017]}
      ]
    },

    {
      s:'triumph-bonneville-t100',
      l:'TRIUMPH BONNEVILLE T100',
      y:[2016,2017,2018,2019],

      g:[
        {id:'triumph-bonneville-t100-gen2',years:[2016,2017,2018,2019]}
      ]
    },

    {
      s:'triumph-bonneville-t120',
      l:'TRIUMPH BONNEVILLE T120',
      y:[2016,2017,2018,2019],

      g:[
        {id:'triumph-bonneville-t120-gen1',years:[2016,2017,2018,2019]}
      ]
    },

    {
      s:'triumph-street-twin',
      l:'TRIUMPH STREET TWIN',
      y:[2016,2017,2018],

      g:[
        {id:'triumph-street-twin-gen1',years:[2016,2017,2018]}
      ]
    },

    {
      s:'triumph-street-cup',
      l:'TRIUMPH STREET CUP',
      y:[2017,2018,2019],

      g:[
        {id:'triumph-street-cup-gen1',years:[2017,2018,2019]}
      ]
    },

    {
      s:'triumph-thruxton-1200',
      l:'TRIUMPH THRUXTON 1200',
      y:[2016,2017,2018,2019],

      g:[
        {id:'triumph-thruxton-1200-gen1',years:[2016,2017,2018,2019]}
      ]
    },

    {
      s:'triumph-bonneville-bobber',
      l:'TRIUMPH BONNEVILLE BOBBER',
      y:[2017,2018,2019,2020],

      g:[
        {id:'triumph-bonneville-bobber-gen1',years:[2017,2018,2019,2020]}
      ]
    },

    {
      s:'triumph-street-scrambler-new',
      l:'TRIUMPH STREET SCRAMBLER (NEW)',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-street-scrambler-new-gen1',years:[2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'triumph-street-twin-new',
      l:'TRIUMPH STREET TWIN (NEW)',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-street-twin-new-gen1',years:[2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'triumph-bonneville-speedmaster',
      l:'TRIUMPH BONNEVILLE SPEEDMASTER',
      y:[2018,2019,2020],

      g:[
        {id:'triumph-bonneville-speedmaster-gen1',years:[2018,2019,2020]}
      ]
    },

    {
      s:'triumph-speed-twin',
      l:'TRIUMPH SPEED TWIN',
      y:[2019],

      g:[
        {id:'triumph-speed-twin-gen1',years:[2019]}
      ]
    },

    {
      s:'triumph-thruxton-900',
      l:'TRIUMPH THRUXTON 900',
      y:[2015],

      g:[
        {id:'triumph-thruxton-900-gen2',years:[2015]}
      ]
    },

    {
      s:'triumph-bonneville-t100',
      l:'TRIUMPH BONNEVILLE T100',
      y:[2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015],

      g:[
        {id:'triumph-bonneville-t100-gen1',years:[2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015]}
      ]
    },

    {
      s:'triumph-daytona-675',
      l:'TRIUMPH DAYTONA 675',
      y:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017],

      g:[
        {id:'triumph-daytona-675-gen1',years:[2006,2007,2008,2009,2010,2011,2012]},
        {id:'triumph-daytona-675-gen2',years:[2013,2014,2015,2016,2017]}
      ]
    },

    {
      s:'triumph-scrambler',
      l:'TRIUMPH SCRAMBLER',
      y:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015],

      g:[
        {id:'triumph-scrambler-gen1',years:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015]}
      ]
    },

    {
      s:'triumph-street-triple-675',
      l:'TRIUMPH STREET TRIPLE 675',
      y:[2008,2009,2010,2011,2012,2013,2014,2015,2016],

      g:[
        {id:'triumph-street-triple-675-gen1',years:[2008,2009,2010,2011,2012,2013,2014,2015,2016]}
      ]
    },

    {
      s:'triumph-street-triple-675r',
      l:'TRIUMPH STREET TRIPLE 675R',
      y:[2008,2009,2010,2011,2012,2013,2014,2015,2016],

      g:[
        {id:'triumph-street-triple-675r-gen1',years:[2008,2009,2010,2011,2012,2013,2014,2015,2016]}
      ]
    },

    {
      s:'triumph-thruxton-900',
      l:'TRIUMPH THRUXTON 900',
      y:[2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014],

      g:[
        {id:'triumph-thruxton-900-gen1',years:[2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014]}
      ]
    },

    {
      s:'triumph-street-triple-675',
      l:'TRIUMPH STREET TRIPLE 675',
      y:[2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017],

      g:[
        {id:'triumph-street-triple-675-gen1',years:[2007,2008,2009,2010]},
        {id:'triumph-street-triple-675-gen2',years:[2011,2012,2013,2014,2015,2016,2017]}
      ]
    },

    {
      s:'triumph-street-triple-765-r',
      l:'TRIUMPH STREET TRIPLE 765 R',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-street-triple-765-r-gen1',years:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },
    {
      s:'triumph-street-triple-765-rs',
      l:'TRIUMPH STREET TRIPLE 765 RS',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-street-triple-765-rs-gen1',years:[2017,2018,2019,2020,2021,2022]},
        {id:'triumph-street-triple-765-rs-gen2',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'triumph-street-triple-765-moto2',
      l:'TRIUMPH STREET TRIPLE 765 MOTO2',
      y:[2023,2024,2025,2026,2027],

      g:[
        {id:'triumph-street-triple-765-moto2-gen1',years:[2023,2024,2025,2026,2027]},
      ]
    },
   

    {
      s:'triumph-street-triple-r',
      l:'TRIUMPH STREET TRIPLE R',
      y:[2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-street-triple-r-gen1',years:[2008,2009,2010,2011,2012]},
        {id:'triumph-street-triple-r-gen2',years:[2013,2014,2015,2016,2017]},
        {id:'triumph-street-triple-r-gen3',years:[2018,2019,2020,2021,2022]},
        {id:'triumph-street-triple-r-gen4',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'triumph-street-triple-rs',
      l:'TRIUMPH STREET TRIPLE RS',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-street-triple-rs-gen1',years:[2017,2018,2019,2020,2021,2022]},
        {id:'triumph-street-triple-rs-gen2',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'triumph-speed-triple-1050',
      l:'TRIUMPH SPEED TRIPLE 1050',
      y:[2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020],

      g:[
        {id:'triumph-speed-triple-1050-gen1',years:[2005,2006,2007,2008,2009,2010]},
        {id:'triumph-speed-triple-1050-gen2',years:[2011,2012,2013,2014,2015,2016]},
        {id:'triumph-speed-triple-1050-gen3',years:[2017,2018,2019,2020]}
      ]
    },

    {
      s:'triumph-speed-triple-1200-rs',
      l:'TRIUMPH SPEED TRIPLE 1200 RS',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-speed-triple-1200-rs-gen1',years:[2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'triumph-tiger-800',
      l:'TRIUMPH TIGER 800',
      y:[2010,2011,2012,2013,2014],

      g:[
        {id:'triumph-tiger-800-gen1',years:[2010,2011,2012,2013,2014]}
      ]
    },

    {
      s:'triumph-tiger-900',
      l:'TRIUMPH TIGER 900',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-tiger-900-gen1',years:[2020,2021,2022,2023]},
        {id:'triumph-tiger-900-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'triumph-tiger-1200',
      l:'TRIUMPH TIGER 1200',
      y:[2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-tiger-1200-gen1',years:[2012,2013,2014,2015,2016,2017]},
        {id:'triumph-tiger-1200-gen2',years:[2018,2019,2020,2021]},
        {id:'triumph-tiger-1200-gen3',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'triumph-tiger-sport-660',
      l:'TRIUMPH TIGER SPORT 660',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-tiger-sport-660-gen1',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'triumph-tiger-sport-1050',
      l:'TRIUMPH TIGER SPORT 1050',
      y:[2016,2017,2018,2019,2020,2021],

      g:[
        {id:'triumph-tiger-sport-1050-gen1',years:[2016,2017,2018,2019,2020,2021]}
      ]
    },

    {
      s:'triumph-bonneville-t100',
      l:'TRIUMPH BONNEVILLE T100',
      y:[2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-bonneville-t100-gen1',years:[2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016]},
        {id:'triumph-bonneville-t100-gen2',years:[2017,2018,2019]}
      ]
    },

    {
      s:'triumph-bonneville-t120',
      l:'TRIUMPH BONNEVILLE T120',
      y:[2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-bonneville-t120-gen1',years:[2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]},
      ]
    },

    {
      s:'triumph-scrambler-900',
      l:'TRIUMPH SCRAMBLER 900',
      y:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-scrambler-900-gen1',years:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015]},
        {id:'triumph-scrambler-900-gen2',years:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'triumph-scrambler-1200',
      l:'TRIUMPH SCRAMBLER 1200',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-scrambler-1200-gen1',years:[2019,2020,2021,2022,2023]},
        {id:'triumph-scrambler-1200-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'triumph-thruxton-1200',
      l:'TRIUMPH THRUXTON 1200',
      y:[2016,2017,2018,2019,2020,2021,2022,2023,2024],

      g:[
        {id:'triumph-thruxton-1200-gen1',years:[2016,2017,2018,2019,2020]},
        {id:'triumph-thruxton-1200-gen2',years:[2021,2022,2023,2024]}
      ]
    },

    {
      s:'triumph-daytona-675',
      l:'TRIUMPH DAYTONA 675',
      y:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016],

      g:[
        {id:'triumph-daytona-675-gen1',years:[2006,2007,2008,2009]},
        {id:'triumph-daytona-675-gen2',years:[2010,2011,2012]},
        {id:'triumph-daytona-675-gen3',years:[2013,2014,2015,2016]}
      ]
    },

    {
      s:'triumph-rocket-3',
      l:'TRIUMPH ROCKET 3',
      y:[2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'triumph-rocket-3-gen1',years:[2004,2005,2006,2007,2008,2009]},
        {id:'triumph-rocket-3-gen2',years:[2010,2011,2012,2013,2014,2015,2016,2017,2018]},
        {id:'triumph-rocket-3-gen3',years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

   {
      s:'triumph-trident-660',
      l:'TRIUMPH TRIDENT 660',
      y:[2021,2022,2023,2024],

      g:[
        {id:'triumph-trident-660-gen1',years:[2021,2022,2023,2024]},
     
      ]
    },

  ],

  'YAMAHA': [

    {
      s:'yamaha-fzr1000-genesis',
      l:'YAMAHA FZR1000 GENESIS',
      y:[1987,1988],

      g:[
        {id:'yamaha-fzr1000-gen1',years:[1987,1988]}
      ]
    },

    {
      s:'yamaha-fzr600r',
      l:'YAMAHA FZR600R',
      y:[1994,1995],

      g:[
        {id:'yamaha-fzr600r-gen1',years:[1994,1995]}
      ]
    },

    {
      s:'yamaha-fzr-750rt-genesis',
      l:'YAMAHA FZR 750RT GENESIS',
      y:[1987,1988],

      g:[
        {id:'yamaha-fzr750rt-gen1',years:[1987,1988]}
      ]
    },

    {
      s:'yamaha-tdm850',
      l:'YAMAHA TDM850',
      y:[1991,1992,1993],

      g:[
        {id:'yamaha-tdm850-gen1',years:[1991,1992,1993]}
      ]
    },

    {
      s:'yamaha-trx850',
      l:'YAMAHA TRX850',
      y:[1996,1997,1998,1999,2000],

      g:[
        {id:'yamaha-trx850-gen1',years:[1996,1997,1998,1999,2000]}
      ]
    },

    {
      s:'yamaha-xj600n',
      l:'YAMAHA XJ600N',
      y:[1999,2000,2001],

      g:[
        {id:'yamaha-xj600n-gen1',years:[1999,2000,2001]}
      ]
    },

    {
      s:'yamaha-xj600s-diversion',
      l:'YAMAHA XJ600S DIVERSION',
      y:[1984,1985,1986,1987,1988,1989,1990,1991],

      g:[
        {id:'yamaha-xj600s-diversion-gen1',years:[1984,1985,1986,1987,1988,1989,1990,1991]}
      ]
    },

    {
      s:'yamaha-xj900s',
      l:'YAMAHA XJ900S',
      y:[1995,1996,1997,1998,1999,2000,2001,2002,2003],

      g:[
        {id:'yamaha-xj900s-gen1',years:[1995,1996,1997,1998,1999,2000,2001,2002,2003]}
      ]
    },

    {
      s:'yamaha-fzs600-fazer',
      l:'YAMAHA FZS600 FAZER',
      y:[1998,1999,2000,2001,2002,2003],

      g:[
        {id:'yamaha-fzs600-fazer-gen1',years:[1998,1999,2000,2001,2002,2003]}
      ]
    },

    {
      s:'yamaha-xv1700-warrior',
      l:'YAMAHA XV1700 WARRIOR',
      y:[2003,2004,2005],

      g:[
        {id:'yamaha-xv1700-warrior-gen1',years:[2003,2004,2005]}
      ]
    },

    {
      s:'yamaha-xv950',
      l:'YAMAHA XV950',
      y:[2013,2014,2015],

      g:[
        {id:'yamaha-xv950-gen1',years:[2013,2014,2015]}
      ]
    },

    {
      s:'yamaha-xvs1100-dragstar',
      l:'YAMAHA XVS1100 DRAGSTAR',
      y:[1999,2000,2001,2002,2003,2004,2005,2006,2007],

      g:[
        {id:'yamaha-xvs1100-dragstar-gen1',years:[1999,2000,2001,2002,2003,2004,2005,2006,2007]}
      ]
    },

    {
      s:'yamaha-yzf-600r-thunder-cat',
      l:'YAMAHA YZF-600R THUNDER CAT',
      y:[1996,1997,1998,1999,2000,2001,2002],

      g:[
        {id:'yamaha-yzf-600r-thunder-cat-gen1',years:[1996,1997,1998,1999,2000,2001,2002]}
      ]
    },

    {
      s:'yamaha-yzf-750r',
      l:'YAMAHA YZF-750R',
      y:[1994,1995,1996,1997],

      g:[
        {id:'yamaha-yzf-750r-gen1',years:[1994,1995,1996,1997]}
      ]
    },

    {
      s:'yamaha-yzf-750r-sp',
      l:'YAMAHA YZF-750R SP',
      y:[1993,1994,1995,1996,1997,1998],

      g:[
        {id:'yamaha-yzf-750r-sp-gen1',years:[1993,1994,1995,1996,1997,1998]}
      ]
    },

    {
      s:'yamaha-fj1100',
      l:'YAMAHA FJ1100',
      y:[1984,1985],

      g:[
        {id:'yamaha-fj1100-gen1',years:[1984,1985]}
      ]
    },

    {
      s:'yamaha-fj1200',
      l:'YAMAHA FJ1200',
      y:[1986,1987,1988,1989,1990,1991,1992],

      g:[
        {id:'yamaha-fj1200-gen1',years:[1986,1987]},
        {id:'yamaha-fj1200-gen2',years:[1988,1989]},
        {id:'yamaha-fj1200-gen3',years:[1991,1992]}
      ]
    },

    {
      s:'yamaha-tdm850',
      l:'YAMAHA TDM850',
      y:[1991,1992,1993],

      g:[
        {id:'yamaha-tdm850-gen1',years:[1991,1992,1993]}
      ]
    },

    {
      s:'yamaha-trx850',
      l:'YAMAHA TRX850',
      y:[1996,1997,1998,1999,2000],

      g:[
        {id:'yamaha-trx850-gen1',years:[1996,1997,1998,1999,2000]}
      ]
    },

    {
      s:'yamaha-xj600n',
      l:'YAMAHA XJ600N',
      y:[1999,2000,2001],

      g:[
        {id:'yamaha-xj600n-gen1',years:[1999,2000,2001]}
      ]
    },

    {
      s:'yamaha-xj600s-diversion',
      l:'YAMAHA XJ600S DIVERSION',
      y:[1984,1985,1986,1987,1988,1989,1990,1991],

      g:[
        {id:'yamaha-xj600s-diversion-gen1',years:[1984,1985,1986,1987,1988,1989,1990,1991]}
      ]
    },

    {
      s:'yamaha-xj900s',
      l:'YAMAHA XJ900S',
      y:[1995,1996,1997,1998,1999,2000,2001,2002,2003],

      g:[
        {id:'yamaha-xj900s-gen1',years:[1995,1996,1997,1998,1999,2000,2001,2002,2003]}
      ]
    },

    {
      s:'yamaha-fzs600-fazer',
      l:'YAMAHA FZS600 FAZER',
      y:[1998,1999,2000,2001,2002,2003],

      g:[
        {id:'yamaha-fzs600-fazer-gen1',years:[1998,1999,2000,2001,2002,2003]}
      ]
    },

    {
      s:'yamaha-xv1700-warrior',
      l:'YAMAHA XV1700 WARRIOR',
      y:[2003,2004,2005],

      g:[
        {id:'yamaha-xv1700-warrior-gen1',years:[2003,2004,2005]}
      ]
    },

    {
      s:'yamaha-xv950',
      l:'YAMAHA XV950',
      y:[2013,2014,2015],

      g:[
        {id:'yamaha-xv950-gen1',years:[2013,2014,2015]}
      ]
    },

    {
      s:'yamaha-xvs1100-dragstar',
      l:'YAMAHA XVS1100 DRAGSTAR',
      y:[1999,2000,2001,2002,2003,2004,2005,2006,2007],

      g:[
        {id:'yamaha-xvs1100-dragstar-gen1',years:[1999,2000,2001,2002,2003,2004,2005,2006,2007]}
      ]
    },

    {
      s:'yamaha-yzf-600r-thunder-cat',
      l:'YAMAHA YZF-600R THUNDER CAT',
      y:[1996,1997,1998,1999,2000,2001,2002],

      g:[
        {id:'yamaha-yzf-600r-thunder-cat-gen1',years:[1996,1997,1998,1999,2000,2001,2002]}
      ]
    },

    {
      s:'yamaha-yzf-750r',
      l:'YAMAHA YZF-750R',
      y:[1994,1995,1996,1997],

      g:[
        {id:'yamaha-yzf-750r-gen1',years:[1994,1995,1996,1997]}
      ]
    },

    {
      s:'yamaha-yzf-750r-sp',
      l:'YAMAHA YZF-750R SP',
      y:[1993,1994,1995,1996,1997,1998],

      g:[
        {id:'yamaha-yzf-750r-sp-gen1',years:[1993,1994,1995,1996,1997,1998]}
      ]
    },

    {
      s:'yamaha-yzf-r3',
      l:'YAMAHA YZF-R3',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-yzf-r3-gen1',years:[2015,2018]},
        {id:'yamaha-yzf-r3-gen2',years:[2019,2024]},
        {id:'yamaha-yzf-r3-gen3',years:[2025,2026]}
      ]
    },

    {
      s:'yamaha-mt-09-sp',
      l:'YAMAHA MT-09 SP',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-mt-09-sp-gen1',years:[2018,2020]},
        {id:'yamaha-mt-09-sp-gen2',years:[2021,2023]},
        {id:'yamaha-mt-09-sp-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-mt-09-tracer',
      l:'YAMAHA MT-09 TRACER',
      y:[2015,2016,2017],

      g:[
        {id:'yamaha-mt-09-tracer-gen1',years:[2015,2016,2017]}
      ]
    },

    {
      s:'yamaha-tracer-700',
      l:'YAMAHA TRACER 700',
      y:[2016,2017,2018,2019],

      g:[
        {id:'yamaha-tracer-700-gen1',years:[2016,2017,2018,2019]}
      ]
    },

    {
      s:'yamaha-tracer-900',
      l:'YAMAHA TRACER 900',
      y:[2018,2019,2020],

      g:[
        {id:'yamaha-tracer-900-gen1',years:[2018,2019,2020]}
      ]
    },

    {
      s:'yamaha-tracer-900gt',
      l:'YAMAHA TRACER 900GT',
      y:[2018,2019,2020],

      g:[
        {id:'yamaha-tracer-900gt-gen1',years:[2018,2019,2020]}
      ]
    },

    {
      s:'yamaha-xsr700',
      l:'YAMAHA XSR700',
      y:[2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026,2027],

      g:[
        {id:'yamaha-xsr700-gen1',years:[2016,2017,2018,2019,2020,2021]},
        {id:'yamaha-xsr700-gen2',years:[2022,2023,2024,2025,2026,2027]}
      ]
    },

    {
      s:'yamaha-xsr900',
      l:'YAMAHA XSR900',
      y:[2016,2017,2018,2019],

      g:[
        {id:'yamaha-xsr900-gen1',years:[2016,2017,2018,2019,2020,2021]},
        {id:'yamaha-xsr900-gen2',years:[2022,2023,2024,2025,2026,2027]}
      ]
    },

    {
      s:'yamaha-mt-03',
      l:'YAMAHA MT-03',
      y:[2016,2017,2018],

      g:[
        {id:'yamaha-mt-03-gen1',years:[2016,2017,2018]}
      ]
    },

    {
      s:'yamaha-yzf-r1',
      l:'YAMAHA YZF-R1',
      y:[1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-yzf-r1-gen1',years:[1998,1999]},
        {id:'yamaha-yzf-r1-gen2',years:[2000,2001]},
        {id:'yamaha-yzf-r1-gen3',years:[2002,2003]},
        {id:'yamaha-yzf-r1-gen4',years:[2004,2005]},
        {id:'yamaha-yzf-r1-gen5',years:[2006,2007]},
        {id:'yamaha-yzf-r1-gen6',years:[2008,2009]},
        {id:'yamaha-yzf-r1-gen7',years:[2010,2011,2012,2013,2014]},
        {id:'yamaha-yzf-r1-gen8',years:[2015,2016,2017,2018,2019]},
        {id:'yamaha-yzf-r1-gen9',years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-yzf-r6',
      l:'YAMAHA YZF-R6',
      y:[1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021],

      g:[
        {id:'yamaha-yzf-r6-gen1',years:[1999,2000]},
        {id:'yamaha-yzf-r6-gen2',years:[2001,2002]},
        {id:'yamaha-yzf-r6-gen3',years:[2003,2004,2005]},
        {id:'yamaha-yzf-r6-gen4',years:[2006,2007]},
        {id:'yamaha-yzf-r6-gen5',years:[2008,2009,2010]},
        {id:'yamaha-yzf-r6-gen6',years:[2011,2012,2013,2014,2015,2016]},
        {id:'yamaha-yzf-r6-gen7',years:[2017,2018,2019,2020,2021]}
      ]
    },

    {
      s:'yamaha-mt-09',
      l:'YAMAHA MT-09(FZ-09)',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-mt-09-gen1',years:[2014,2015,2016]},
        {id:'yamaha-mt-09-gen2',years:[2017,2018,2019,2020]},
        {id:'yamaha-mt-09-gen3',years:[2021,2022,2023]},
        {id:'yamaha-mt-09-gen4',years:[2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-mt-09-sp',
      l:'YAMAHA MT-09 SP',
      y:[2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-mt-09-sp-gen1',years:[2018,2019,2020]},
        {id:'yamaha-mt-09-sp-gen2',years:[2021,2022,2023]},
        {id:'yamaha-mt-09-sp-gen3',years:[2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-mt-07',
      l:'YAMAHA MT-07(FZ-07)',
      y:[2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-mt-07-gen1',years:[2014,2015,2016]},
        {id:'yamaha-mt-07-gen2',years:[2018,2019,2020,2021]},
        {id:'yamaha-mt-07-gen3',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-mt-10',
      l:'YAMAHA MT-10',
      y:[2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-mt-10-gen1',years:[2016,2017,2018,2019,2020,2021]},
        {id:'yamaha-mt-10-gen2',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-mt-10-sp',
      l:'YAMAHA MT-10 SP',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-mt-10-sp-gen1',years:[2017,2018,2019,2020,2021]},
        {id:'yamaha-mt-10-sp-gen2',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-tracer-900',
      l:'YAMAHA TRACER 900',
      y:[2015,2016,2017,2018,2019,2020],

      g:[
        {id:'yamaha-tracer-900-gen1',years:[2015,2016,2017]},
        {id:'yamaha-tracer-900-gen2',years:[2018,2019,2020]}
      ]
    },

    {
      s:'yamaha-tracer-9',
      l:'YAMAHA TRACER 9',
      y:[2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-tracer-9-gen1',years:[2021,2022,2023,2024]},
        {id:'yamaha-tracer-9-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'yamaha-tracer-9-gt',
      l:'YAMAHA TRACER 9 GT',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-tracer-9-gt-gen1',years:[2019,2020]},
        {id:'yamaha-tracer-9-gt-gen2',years:[2021,2026]}
      ]
    },

    {
      s:'yamaha-tenere-700',
      l:'YAMAHA TÉNÉRÉ 700',
      y:[2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-tenere-700-gen1',years:[2019,2020,2021,2022,2023]},
        {id:'yamaha-tenere-700-gen2',years:[2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-tenere-700-world-raid',
      l:'YAMAHA TÉNÉRÉ 700 WORLD RAID',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-tenere-700-world-raid-gen1',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-tenere-700-extreme',
      l:'YAMAHA TÉNÉRÉ 700 EXTREME',
      y:[2024,2025,2026],

      g:[
        {id:'yamaha-tenere-700-extreme-gen1',years:[2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-xsr700',
      l:'YAMAHA XSR700',
      y:[2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-xsr700-gen1',years:[2016,2017,2018,2019,2020,2021]},
        {id:'yamaha-xsr700-gen2',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-xsr900',
      l:'YAMAHA XSR900',
      y:[2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-xsr900-gen1',years:[2016,2017,2018,2019,2020,2021]},
        {id:'yamaha-xsr900-gen2',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-fz1',
      l:'YAMAHA FZ1',
      y:[2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015],

      g:[
        {id:'yamaha-fz1-gen1',years:[2001,2002,2003,2004,2005]},
        {id:'yamaha-fz1-gen2',years:[2006,2007,2008,2009,2010,2011,2012,2013,2014,2015]}
      ]
    },

    {
      s:'yamaha-fjr1300',
      l:'YAMAHA FJR1300',
      y:[2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015],

      g:[
        {id:'yamaha-fjr1300-gen1',years:[2001,2002,2003,2004,2005]},
        {id:'yamaha-fjr1300-gen2',years:[2006,2007,2008,2009,2010,2011,2012]},
        {id:'yamaha-fjr1300-gen3',years:[2013,2014,2015]}
      ]
    },

    {
      s:'yamaha-fjr1300-es',
      l:'YAMAHA FJR1300ES',
      y:[2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-fjr1300-es-gen1',years:[2013,2014,2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-super-tenere-1200',
      l:'YAMAHA SUPER TÉNÉRÉ 1200',
      y:[2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020,2021,2022],

      g:[
        {id:'yamaha-super-tenere-1200-gen1',years:[2010,2011,2012,2013]},
        {id:'yamaha-super-tenere-1200-gen2',years:[2014,2015,2016,2017,2018,2019,2020,2021,2022]}
      ]
    },

    {
      s:'yamaha-tmax-530',
      l:'YAMAHA TMAX 530',
      y:[2012,2013,2014,2015,2016,2017],

      g:[
        {id:'yamaha-tmax-530-gen1',years:[2012,2013,2014,2015,2016,2017]}
      ]
    },

    {
      s:'yamaha-tmax-560',
      l:'YAMAHA TMAX 560',
      y:[2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-tmax-560-gen1',years:[2020,2021,2022,2023,2024]},
        {id:'yamaha-tmax-560-gen2',years:[2025,2026]}
      ]
    },

    {
      s:'yamaha-xmax-300',
      l:'YAMAHA XMAX 300',
      y:[2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-xmax-300-gen1',years:[2017,2018,2019,2020,2021,2022]},
        {id:'yamaha-xmax-300-gen2',years:[2023,2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-mt-03',
      l:'YAMAHA MT-03',
      y:[2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-mt-03-gen1',years:[2016,2017,2018,2019]},
        {id:'yamaha-mt-03-gen2',years:[2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-yzf-r3',
      l:'YAMAHA YZF-R3',
      y:[2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-yzf-r3-gen1',years:[2015,2016,2017,2018]},
        {id:'yamaha-yzf-r3-gen2',years:[2019,2020,2021,2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-yzf-r7',
      l:'YAMAHA YZF-R7',
      y:[2022,2023,2024,2025,2026],

      g:[
        {id:'yamaha-yzf-r7-gen1',years:[2022,2023,2024,2025,2026]}
      ]
    },

    {
      s:'yamaha-xj6',
      l:'YAMAHA XJ6',
      y:[2009,2010,2011,2012,2013,2014,2015,2016],

      g:[
        {id:'yamaha-xj6-gen1',years:[2009,2010,2011,2012,2013,2014,2015,2016]}
      ]
    },
  ]
};